"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5844],{

/***/ 53840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ecommerce_Grid_Grid; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Grid/Grid.styles.js

var _templateObject;


var Box = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Grid/Grid.js




var Grid_Grid = function Grid(_ref) {
  var StaticProps = _ref["static"],
    children = _ref.children;
  return react.createElement(Box, StaticProps, children);
};
 false ? 0 : void 0;
Grid_Grid.defaultProps = {
  "static": {}
};
Grid_Grid.ssr = true;
/* harmony default export */ var ecommerce_Grid_Grid = ((0,withLayoutProps/* default */.Z)(Grid_Grid));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Grid/index.js


/***/ }),

/***/ 54578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ecommerce_Header_Header; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Header/index.js + 2 modules
var Header = __webpack_require__(71782);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 39 modules
var structure_build_esm = __webpack_require__(48728);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/commons/index.js + 3 modules
var commons = __webpack_require__(46729);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SidebarMenuPMD/index.js + 4 modules
var SidebarMenuPMD = __webpack_require__(99028);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Header/renderCustomSidebar.js


var customSidebars = {
  SidebarMenuPMD: SidebarMenuPMD/* default */.Z
};
var renderCustomSidebar = function renderCustomSidebar(sidebar, props) {
  var hasSidebar = sidebar && customSidebars[sidebar];
  return hasSidebar ? (0,react.createElement)(customSidebars[sidebar], props) : null;
};
/* harmony default export */ var Header_renderCustomSidebar = (renderCustomSidebar);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Header/parseHeaderData.js

var parseHeaderData = function parseHeaderData(_ref) {
  var _data$allCategories, _menuData$data, _menuData$data$catego, _menuData$data2, _menuData$data2$accou, _data$channel, _data$channel$data, _data$channel$data$fi, _menuData$data3;
  var staticProps = _ref.staticProps,
    structure = _ref.structure,
    data = _ref.data;
  var _staticProps$menuData = staticProps.menuData,
    menuData = _staticProps$menuData === void 0 ? {
      data: data
    } : _staticProps$menuData,
    headerData = staticProps.headerData;
  var _ref2 = structure.cookies || {},
    _ref2$accountData = _ref2.accountData,
    accountData = _ref2$accountData === void 0 ? {} : _ref2$accountData;
  var parserPmd = menuData.data.pmdHeader;
  var categoryList = (data == null ? void 0 : (_data$allCategories = data.allCategories) == null ? void 0 : _data$allCategories.map(function (_ref3) {
    var _structure$config;
    var id = _ref3.id,
      label = _ref3.label,
      description = _ref3.description,
      meta = _ref3.meta;
    return {
      id: id,
      label: label,
      url: ((structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.domain) || '') + ((0,build_esm/* parseCanonical */.$f)(meta == null ? void 0 : meta.canonical) || "/".concat((0,build_esm/* slug */.oF)(description), "/l/").concat((0,build_esm/* slug */.oF)(id), "/"))
    };
  })) || [];
  if ((menuData == null ? void 0 : (_menuData$data = menuData.data) == null ? void 0 : (_menuData$data$catego = _menuData$data.categoryList) == null ? void 0 : _menuData$data$catego.list) !== undefined && parserPmd) {
    menuData.data.categoryList.list = categoryList;
  }
  if ((menuData == null ? void 0 : (_menuData$data2 = menuData.data) == null ? void 0 : (_menuData$data2$accou = _menuData$data2.account) == null ? void 0 : _menuData$data2$accou.name) !== undefined && (accountData == null ? void 0 : accountData.name)) {
    menuData.data.account.name = accountData.name;
  }
  var showcases = (data == null ? void 0 : (_data$channel = data.channel) == null ? void 0 : (_data$channel$data = _data$channel.data) == null ? void 0 : (_data$channel$data$fi = _data$channel$data.find(function (item) {
    return item.name === 'showcases';
  })) == null ? void 0 : _data$channel$data$fi.value) || [];
  if ((menuData == null ? void 0 : menuData.data) && showcases && showcases.length) {
    menuData.data.showcaseLinks = showcases;
  }
  if ((accountData == null ? void 0 : accountData.name) && (menuData == null ? void 0 : (_menuData$data3 = menuData.data) == null ? void 0 : _menuData$data3.header)) {
    menuData.data.header.label = menuData.data.header.loggedLabel;
    menuData.data.header.url = menuData.data.header.loggedUrl;
  }
  return {
    headerData: headerData,
    menuData: menuData
  };
};
/* harmony default export */ var Header_parseHeaderData = (parseHeaderData);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Header/Header.js













function Header_Header(_ref) {
  var _headerData$logo, _structure$route3;
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var headerData = staticProps.headerData,
    searchUrl = staticProps.searchUrl,
    customSidebar = staticProps.customSidebar,
    relativePathRedirect = staticProps.relativePathRedirect;
  var logoPrefix = headerData == null ? void 0 : (_headerData$logo = headerData.logo) == null ? void 0 : _headerData$logo.prefix;
  var _ref2 = structure.route || {},
    _ref2$term = _ref2.term,
    initialQuery = _ref2$term === void 0 ? '' : _ref2$term,
    storeName = _ref2.storeId;
  var _ref3 = structure.cookies || {},
    partnerId = _ref3.partnerId;
  var _useSuggestions = (0,esm.useSuggestions)({
      partnerId: partnerId
    }),
    suggestions = _useSuggestions.suggestions,
    getSuggestions = _useSuggestions.getSuggestions,
    cleanSuggestions = _useSuggestions.cleanSuggestions;
  var _useState = (0,react.useState)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    chosenSuggestion = _useState2[0],
    setChosenSuggestion = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    showTopTerms = _useState4[0],
    setShowTopTerms = _useState4[1];
  var _useState5 = (0,react.useState)(false),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    isRendered = _useState6[0],
    setIsRendered = _useState6[1];
  var _useTopTerms = (0,esm.useTopTerms)(),
    _useTopTerms$topTerms = _useTopTerms.topTerms,
    _useTopTerms$topTerms2 = _useTopTerms$topTerms.label,
    topTermsLabel = _useTopTerms$topTerms2 === void 0 ? '' : _useTopTerms$topTerms2,
    _useTopTerms$topTerms3 = _useTopTerms$topTerms.terms,
    topTermsList = _useTopTerms$topTerms3 === void 0 ? [] : _useTopTerms$topTerms3;
  var topTermsProps = (0,build_esm/* adaptUseTopTermsToStereoHeaderProps */.ac)({
    showTopTerms: showTopTerms,
    topTermsLabel: topTermsLabel,
    topTermsList: topTermsList
  });
  var _useState7 = (0,react.useState)(initialQuery),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    term = _useState8[0],
    setTerm = _useState8[1];
  var parsedData = Header_parseHeaderData({
    data: data,
    staticProps: staticProps,
    structure: structure
  });
  var logoProps = staticProps.logoProps || {
    prefix: logoPrefix,
    storeName: storeName
  };
  var publishSuggestionFromRoute = function publishSuggestionFromRoute(suggestion) {
    var position = suggestions.findIndex(function (item) {
      return item.term === suggestion;
    }) + 1;
    publish('suggestion:click', {
      position: position,
      term: suggestion
    });
  };
  (0,react.useEffect)(function () {
    var _structure$route;
    if (chosenSuggestion && chosenSuggestion.includes(structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.term)) {
      var _structure$route2;
      publishSuggestionFromRoute(structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term);
    }
  }, [structure == null ? void 0 : (_structure$route3 = structure.route) == null ? void 0 : _structure$route3.term, chosenSuggestion]);
  (0,react.useEffect)(function () {
    setTimeout(function () {
      setIsRendered(true);
    }, 1000);
  }, []);
  var suggestionLinksProps = (0,react.useMemo)(function () {
    return structure.id === 'home' ? (0,commons/* parseHeaderLinksSuggestions */.D$)(staticProps == null ? void 0 : staticProps.linksSuggestionsData) : {};
  }, [structure.id]);
  (0,react.useEffect)(function () {
    if (suggestionLinksProps && structure.id === 'home') {
      publish('link-suggestions:impression', suggestionLinksProps);
    }
  }, [suggestionLinksProps]);
  var onLogoClick = function onLogoClick(e) {
    e.preventDefault();
    (0,build_esm/* routePush */.dY)({
      path: headerData.logo.url,
      spa: true
    });
  };
  var onSearch = function onSearch(e, newTerm) {
    e.preventDefault();
    var newTermTrim = newTerm.trim();
    if (e.type === 'submit' && newTermTrim) {
      publish('search:submit', {
        term: newTermTrim
      });
    }
    var termStr = newTermTrim ? "".concat((0,structure_build_esm/* termToUrl */.Bl)((0,build_esm/* slug */.oF)(newTermTrim)), "/") : '';
    var newTermUrl = "".concat(searchUrl).concat(searchUrl.endsWith('/') ? '' : '/').concat(termStr);
    (0,build_esm/* routePush */.dY)({
      path: newTermUrl,
      spa: true
    });
  };
  var handleSuggest = function handleSuggest(suggestionsTerm) {
    getSuggestions({
      term: suggestionsTerm
    });
  };
  var handleEventMenuClick = function handleEventMenuClick(label, positionLabel) {
    publish('menu:click', {
      label: label,
      positionLabel: positionLabel
    });
  };
  var onShoppingBagClick = function onShoppingBagClick() {
    publish('shoppingbag:click');
  };
  var handleSuggestionClick = function handleSuggestionClick(suggestion) {
    setChosenSuggestion(suggestion);
  };
  var handleTopTermItemClick = function handleTopTermItemClick(topTerm) {
    setShowTopTerms(false);
    var position = topTerm.index,
      clickedTopTerm = topTerm.term;
    publish('suggestion:topterm:click', {
      position: position,
      term: clickedTopTerm
    });
  };
  var onOpenInput = function onOpenInput() {
    if (term.trim()) {
      setShowTopTerms(false);
      if (suggestions.length === 0) {
        handleSuggest(term);
      }
    } else {
      cleanSuggestions();
      setShowTopTerms(true);
    }
  };
  var onCloseInput = function onCloseInput() {
    setShowTopTerms(false);
    publish('search:close', {
      term: term
    });
  };
  var onClearInput = function onClearInput() {
    publish('search:clear', {
      term: term
    });
    cleanSuggestions();
    setShowTopTerms(true);
  };
  var handleTermTypeChange = function handleTermTypeChange(newTerm) {
    if (newTerm.length === 0) {
      cleanSuggestions();
      setShowTopTerms(true);
    } else {
      setShowTopTerms(false);
    }
    setTerm(newTerm);
    handleSuggest(newTerm);
  };
  var handleLogout = function handleLogout() {
    handleEventMenuClick('sair');
  };
  var _useState9 = (0,react.useState)(false),
    _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
    openAccordion = _useState10[0],
    setOpenAccordion = _useState10[1];
  var handleCollapsedClick = function handleCollapsedClick() {
    setOpenAccordion(!openAccordion);
    handleEventMenuClick('ver-todos-os-departamentos');
  };
  var handleHeaderMenuClick = function handleHeaderMenuClick(e, item) {
    e.preventDefault();
    publish('menu:header:click', {
      label: item == null ? void 0 : item.label,
      structure: structure
    });
    (0,build_esm/* routePush */.dY)({
      path: item == null ? void 0 : item.url,
      spa: true
    });
  };
  var handleMenuItemClick = function handleMenuItemClick(e, item, positionLabel) {
    e.preventDefault();
    handleEventMenuClick(item == null ? void 0 : item.label, positionLabel);
    var url = relativePathRedirect && (item == null ? void 0 : item.path) ? item.path : item == null ? void 0 : item.url;
    (0,build_esm/* routePush */.dY)({
      path: url,
      spa: true
    });
  };
  var handleClickLinkSuggestion = function handleClickLinkSuggestion(e, link) {
    e.preventDefault();
    publish('link-suggestions:click', link);
    (0,build_esm/* routePush */.dY)({
      path: link == null ? void 0 : link.href,
      spa: true
    });
  };
  return react.createElement(Header/* default */.Z, (0,esm_extends/* default */.Z)({
    customSidebar: Header_renderCustomSidebar(customSidebar, {
      data: parsedData,
      onCollapsedClick: handleCollapsedClick,
      onMenuHeaderClick: handleHeaderMenuClick,
      onMenuItemClick: handleMenuItemClick,
      storeName: storeName,
      structure: structure
    }),
    data: parsedData,
    initialValue: term,
    isRendered: isRendered,
    logoProps: logoProps,
    onCollapsedClick: handleCollapsedClick,
    onMenuItemClick: handleMenuItemClick,
    onMenuHeaderClick: handleHeaderMenuClick,
    onInputClear: onClearInput,
    onInputClose: onCloseInput,
    onInputOpen: onOpenInput,
    onLogoClick: onLogoClick,
    onLogout: handleLogout,
    onSearch: onSearch,
    onHeaderSuggestionLinkClick: handleClickLinkSuggestion,
    onShoppingBagClick: onShoppingBagClick,
    onSuggestItemClick: handleSuggestionClick,
    onTopTermItemClick: handleTopTermItemClick,
    onTypeChange: handleTermTypeChange,
    suggestData: suggestions
  }, topTermsProps, suggestionLinksProps));
}
 false ? 0 : void 0;
Header_Header.defaultProps = {
  data: {},
  "static": {
    headerData: {
      logo: {
        name: '',
        prefix: undefined,
        url: '/'
      }
    },
    menuData: {
      data: {
        header: {
          helpers: [],
          label: '',
          url: ''
        },
        moreInformation: []
      }
    },
    relativePathRedirect: false,
    searchUrl: '/busca/'
  },
  structure: {}
};
Header_Header.dataSource = {
  categories: {
    query: 'AllCategoriesQuery'
  },
  channel: {
    query: 'ChannelQuery'
  }
};
Header_Header.ssr = true;
Header_Header.displayName = 'Header';
/* harmony default export */ var ecommerce_Header_Header = ((0,withLayoutProps/* default */.Z)(Header_Header));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Header/index.js


/***/ }),

/***/ 89634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ecommerce_HeaderDesktop_HeaderDesktop; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(282);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../../node_modules/lodash/throttle.js
var throttle = __webpack_require__(12436);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/HeaderDesktop/index.js + 5 modules
var HeaderDesktop = __webpack_require__(42887);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/commons/index.js + 3 modules
var commons = __webpack_require__(46729);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 39 modules
var structure_build_esm = __webpack_require__(48728);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktop/HeaderDesktop.styles.js

var _templateObject;


var Container = styled_components_browser_esm["default"].div.attrs(function () {
  return {
    bg: 'background.primary',
    justifyContent: 'center'
  };
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  ", "\n\n  ul > li:nth-last-child(-n + 2) > div:last-child {\n    right: 0;\n  }\n"])), stereo_ui_styles_build_esm.color);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/LoginMenuPMD/index.js + 7 modules
var LoginMenuPMD = __webpack_require__(6583);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktop/renderCustomLoginMenu.js


var customLoginMenus = {
  LoginMenuPMD: LoginMenuPMD/* default */.Z
};
var renderCustomLoginMenu = function renderCustomLoginMenu(loginMenu, props) {
  var CustomLoginMenu = loginMenu && customLoginMenus[loginMenu];
  return CustomLoginMenu ? react.createElement(CustomLoginMenu, props) : null;
};
/* harmony default export */ var HeaderDesktop_renderCustomLoginMenu = (renderCustomLoginMenu);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/index.js
var ecommerce = __webpack_require__(39509);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktop/adaptMixerToStereoHeaderProps.js


var _excluded = ["adUnit", "footerData", "config", "structure", "baseUrl", "url"],
  _excluded2 = ["logoLuImage"];




var parseMenuUrl = function parseMenuUrl(url, baseUrl) {
  if (url == null ? void 0 : url.startsWith == null ? void 0 : url.startsWith('#')) {
    return url;
  }
  return (0,utils_build_esm/* parsePath */.cP)(url, baseUrl);
};
var mapLoginProps = function mapLoginProps(_ref) {
  var _ref$header = _ref.header,
    loginLinkText = _ref$header.label,
    loginLinkURL = _ref$header.url,
    loginMessage = _ref$header.loginMessage,
    _ref$header$helpers = _ref$header.helpers,
    helpers = _ref$header$helpers === void 0 ? [] : _ref$header$helpers,
    name = _ref.accountData.name;
  return {
    isSignedIn: !!name,
    signedConfig: {
      menuLinks: helpers.map(function (helper) {
        return {
          icon: react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
            name: helper.id
          }),
          label: helper.label,
          url: helper.url
        };
      }),
      username: name ? name.split(' ')[0] : ''
    },
    unsignedConfig: {
      loginLink: {
        color: 'white',
        text: loginLinkText,
        url: loginLinkURL
      },
      message: {
        color: 'white',
        text: loginMessage
      }
    }
  };
};
var mapMenuFooterDataProps = function mapMenuFooterDataProps(menuFooterLinks) {
  return {
    linksList: menuFooterLinks.map(function (link) {
      return (0,esm_extends/* default */.Z)({
        label: link.label,
        url: link.url
      }, stereo_ui_icons_build_esm/* Icon */.JO$ && {
        img: {
          component: react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
            name: link.id
          })
        }
      });
    })
  };
};
var mapLinkMenu = function mapLinkMenu(_ref2) {
  var adUnit = _ref2.adUnit,
    footerData = _ref2.footerData,
    config = _ref2.config,
    structure = _ref2.structure,
    baseUrl = _ref2.baseUrl,
    url = _ref2.url,
    props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);
  return (0,esm_extends/* default */.Z)({}, props, {
    url: parseMenuUrl(url, baseUrl)
  }, adUnit && {
    banner: {
      component: react.createElement(ecommerce.AdsBanner, {
        structure: structure,
        "static": adUnit["static"]
      }),
      width: adUnit["static"].size[0]
    }
  }, footerData && {
    footerData: mapMenuFooterDataProps(footerData.linksList)
  });
};
var mapCategoryList = function mapCategoryList(categoryList, config, structure, baseUrl) {
  var mappedMenuList = Array.isArray(categoryList == null ? void 0 : categoryList.list) ? categoryList == null ? void 0 : categoryList.list.map(function (menu) {
    var _menu$subcategoriesLi;
    return (0,esm_extends/* default */.Z)({}, mapLinkMenu((0,esm_extends/* default */.Z)({}, menu, {
      baseUrl: baseUrl,
      config: config,
      structure: structure
    })), {
      subcategoriesList: (_menu$subcategoriesLi = menu.subcategoriesList) == null ? void 0 : _menu$subcategoriesLi.map(function (item) {
        return (0,esm_extends/* default */.Z)({}, item, {
          url: parseMenuUrl(item.url, baseUrl)
        });
      })
    });
  }) : [];
  return (0,esm_extends/* default */.Z)({}, categoryList, {
    list: mappedMenuList
  });
};
var mapZipCodeProps = function mapZipCodeProps(_ref3) {
  var zipCode = _ref3.zipCode,
    zipCodeBar = _ref3.zipCodeBar,
    zipCodeCity = _ref3.zipCodeCity,
    zipCodeState = _ref3.zipCodeState;
  var zipCodeBarText = zipCodeBar.zipCodeBarText,
    showZipcode = zipCodeBar.showZipcode,
    popper = zipCodeBar.popper;
  return (0,esm_extends/* default */.Z)({}, zipCodeBarText, {
    city: zipCodeCity,
    popper: popper,
    showZipcode: showZipcode,
    state: zipCodeState,
    zipcode: zipCode
  });
};
/* harmony default export */ var adaptMixerToStereoHeaderProps = (function (_ref4) {
  var _staticProps$menuData, _staticProps$menuData2, _staticProps$menuData3, _data$allCategories, _structure$theme;
  var data = _ref4.data,
    staticProps = _ref4.staticProps,
    structure = _ref4.structure,
    config = _ref4.config,
    location = _ref4.location;
  var store = staticProps == null ? void 0 : (_staticProps$menuData = staticProps.menuData) == null ? void 0 : (_staticProps$menuData2 = _staticProps$menuData.data) == null ? void 0 : (_staticProps$menuData3 = _staticProps$menuData2.allCategories) == null ? void 0 : _staticProps$menuData3.store;
  var _staticProps$baseUrl = staticProps.baseUrl,
    baseUrl = _staticProps$baseUrl === void 0 ? '' : _staticProps$baseUrl,
    headerData = staticProps.headerData,
    _staticProps$menuData4 = staticProps.menuData,
    _staticProps$menuData5 = _staticProps$menuData4 === void 0 ? {} : _staticProps$menuData4,
    _staticProps$menuData6 = _staticProps$menuData5.data,
    _staticProps$menuData7 = _staticProps$menuData6 === void 0 ? {} : _staticProps$menuData6,
    _staticProps$menuData8 = _staticProps$menuData7.account,
    account = _staticProps$menuData8 === void 0 ? {} : _staticProps$menuData8,
    _staticProps$menuData9 = _staticProps$menuData7.companyLinks,
    companyLinks = _staticProps$menuData9 === void 0 ? {} : _staticProps$menuData9,
    _staticProps$menuData10 = _staticProps$menuData7.contactLinks,
    contactLinks = _staticProps$menuData10 === void 0 ? {} : _staticProps$menuData10,
    _staticProps$menuData11 = _staticProps$menuData7.specialLinks,
    specialLinks = _staticProps$menuData11 === void 0 ? [] : _staticProps$menuData11,
    _staticProps$menuData12 = _staticProps$menuData7.allCategories,
    allCategories = _staticProps$menuData12 === void 0 ? {} : _staticProps$menuData12,
    _staticProps$menuData13 = _staticProps$menuData7.categoryList,
    categoryList = _staticProps$menuData13 === void 0 ? {} : _staticProps$menuData13,
    _staticProps$menuData14 = _staticProps$menuData7.externalLinks,
    externalLinks = _staticProps$menuData14 === void 0 ? [] : _staticProps$menuData14,
    _staticProps$menuData15 = _staticProps$menuData7.header,
    header = _staticProps$menuData15 === void 0 ? {} : _staticProps$menuData15,
    _staticProps$zipCodeB = staticProps.zipCodeBar,
    zipCodeBar = _staticProps$zipCodeB === void 0 ? {} : _staticProps$zipCodeB;
  var subcategoriesList = ((data == null ? void 0 : (_data$allCategories = data.allCategories) == null ? void 0 : _data$allCategories.map(function (_ref5) {
    var id = _ref5.id,
      label = _ref5.label,
      description = _ref5.description;
    return {
      id: id,
      label: label,
      url: "".concat(baseUrl).concat(store || '', "/").concat((0,utils_build_esm/* slug */.oF)(description), "/l/").concat((0,utils_build_esm/* slug */.oF)(id), "/")
    };
  })) || []).sort(function (a, b) {
    return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
  });
  var _structure$cookies = structure.cookies,
    _structure$cookies2 = _structure$cookies === void 0 ? {} : _structure$cookies,
    _structure$cookies2$a = _structure$cookies2.accountData,
    accountData = _structure$cookies2$a === void 0 ? {} : _structure$cookies2$a,
    _structure$cookies2$r = _structure$cookies2.rejectZipcodePopup,
    rejectZipcodePopup = _structure$cookies2$r === void 0 ? false : _structure$cookies2$r,
    _structure$route = structure.route,
    _structure$route2 = _structure$route === void 0 ? {} : _structure$route,
    storeId = _structure$route2.storeId;
  var zipCode = location.zipCode,
    zipCodeCity = location.zipCodeCity,
    zipCodeState = location.zipCodeState;
  var logoLuPath = (structure == null ? void 0 : (_structure$theme = structure.theme) == null ? void 0 : _structure$theme.name) || 'magazineluiza';
  var _ref6 = staticProps.logoProps || {},
    _ref6$logoLuImage = _ref6.logoLuImage,
    logoLuImage = _ref6$logoLuImage === void 0 ? 'logo-lu' : _ref6$logoLuImage,
    logoPropsRest = (0,objectWithoutProperties/* default */.Z)(_ref6, _excluded2);
  return {
    data: {
      account: account,
      allCategories: mapLinkMenu((0,esm_extends/* default */.Z)({}, allCategories, {
        baseUrl: baseUrl,
        config: config,
        structure: structure,
        subcategoriesList: subcategoriesList
      })),
      categoryList: mapCategoryList(categoryList, config, structure, baseUrl),
      companyLinks: companyLinks,
      contactLinks: contactLinks,
      externalLinks: externalLinks.map(function (externalLink) {
        return mapLinkMenu((0,esm_extends/* default */.Z)({}, externalLink, {
          config: config,
          structure: structure
        }));
      }),
      headerData: headerData,
      login: mapLoginProps({
        accountData: accountData,
        header: header
      }),
      specialLinks: specialLinks.map(function (specialLink) {
        return mapLinkMenu((0,esm_extends/* default */.Z)({}, specialLink, {
          baseUrl: baseUrl,
          config: config,
          structure: structure
        }));
      }),
      zipcode: mapZipCodeProps({
        zipCode: zipCode,
        zipCodeBar: zipCodeBar,
        zipCodeCity: zipCodeCity,
        zipCodeState: zipCodeState
      })
    },
    initialZipcodePopper: !zipCode && !rejectZipcodePopup ? 'info' : null,
    logoLuProps: {
      height: '113px',
      href: "https://wx.mlcdn.com.br/site/desk/header/".concat(logoLuPath, "/").concat(logoLuImage, ".png?ims=69x113"),
      name: 'LogoMagalu',
      titleaccess: 'Logo Lu',
      viewBox: '0 0 69 113',
      width: '69px',
      y: '4'
    },
    logoProps: (0,esm_extends/* default */.Z)({
      storeName: storeId
    }, logoPropsRest)
  };
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktop/adaptUseSuggestionsToStereoHeaderProps.js
var mapProductSuggestions = function mapProductSuggestions(products) {
  return products.map(function (_ref) {
    var variationId = _ref.variationId,
      image = _ref.image,
      title = _ref.title,
      price = _ref.price,
      path = _ref.path;
    return {
      id: variationId,
      img: image == null ? void 0 : image.replace('{w}x{h}', '59x44'),
      path: path,
      price: price.realPrice,
      term: title
    };
  });
};
var mapTermsSuggestions = function mapTermsSuggestions(terms) {
  return terms.map(function (suggestion) {
    return {
      term: suggestion.term
    };
  });
};
/* harmony default export */ var adaptUseSuggestionsToStereoHeaderProps = (function (_ref2) {
  var terms = _ref2.terms,
    products = _ref2.products;
  return {
    searchSuggestions: {
      products: mapProductSuggestions(products),
      terms: mapTermsSuggestions(terms)
    }
  };
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktop/HeaderDesktop.js




function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }















var HEADER_SELECT_CONTENT = 'header:selectContent';
var HEADER_IMPRESSION = 'header:impression';
function HeaderDesktop_HeaderDesktop(_ref) {
  var _structure$route3;
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure,
    config = _ref.config;
  var _ref2 = structure.cookies || {},
    partnerId = _ref2.partnerId,
    cartId = _ref2.cartId,
    customerId = _ref2.customerId,
    toggleWishlist = _ref2.toggleWishlist,
    accountData = _ref2.accountData,
    _ref2$location = _ref2.location,
    location = _ref2$location === void 0 ? {} : _ref2$location;
  var _useState = (0,react.useState)(adaptMixerToStereoHeaderProps({
      config: config,
      data: data,
      location: location,
      staticProps: staticProps,
      structure: structure
    })),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    headerProps = _useState2[0],
    setHeaderProps = _useState2[1];
  var _useState3 = (0,react.useState)(0),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    bagCount = _useState4[0],
    setBagCount = _useState4[1];
  var _useState5 = (0,react.useState)(0),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    wishlistCount = _useState6[0],
    setWishlistCount = _useState6[1];
  var _useState7 = (0,react.useState)(),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    chosenSuggestion = _useState8[0],
    setChosenSuggestion = _useState8[1];
  var _useState9 = (0,react.useState)(false),
    _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
    showTopTerms = _useState10[0],
    setShowTopTerms = _useState10[1];
  var _useState11 = (0,react.useState)(false),
    _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
    isRendered = _useState12[0],
    setIsRendered = _useState12[1];
  var _useState13 = (0,react.useState)(false),
    _useState14 = (0,slicedToArray/* default */.Z)(_useState13, 2),
    isHoverZipcode = _useState14[0],
    seIsHoverZipcode = _useState14[1];
  var searchUrl = staticProps.searchUrl,
    headerData = staticProps.headerData,
    wishlistUrl = staticProps.wishlistUrl,
    wishlistSpa = staticProps.wishlistSpa,
    cartUrl = staticProps.cartUrl,
    menuData = staticProps.menuData,
    linksSuggestionsData = staticProps.linksSuggestionsData,
    customLoginMenu = staticProps.customLoginMenu;
  var _ref3 = (menuData == null ? void 0 : menuData.data) || {},
    _ref3$wishListIconPro = _ref3.wishListIconProps,
    wishListIconProps = _ref3$wishListIconPro === void 0 ? {} : _ref3$wishListIconPro,
    _ref3$bagIconProps = _ref3.bagIconProps,
    bagIconProps = _ref3$bagIconProps === void 0 ? {} : _ref3$bagIconProps;
  var _ref4 = structure.route || {},
    _ref4$term = _ref4.term,
    initialQuery = _ref4$term === void 0 ? '' : _ref4$term;
  var _useState15 = (0,react.useState)(initialQuery),
    _useState16 = (0,slicedToArray/* default */.Z)(_useState15, 2),
    currentTerm = _useState16[0],
    setCurrentTerm = _useState16[1];
  var _useState17 = (0,react.useState)(null),
    _useState18 = (0,slicedToArray/* default */.Z)(_useState17, 2),
    showZipcodePopper = _useState18[0],
    setShowZipcodePopper = _useState18[1];
  var showWishlistCount = toggleWishlist;
  var _useState19 = (0,react.useState)(initialQuery),
    _useState20 = (0,slicedToArray/* default */.Z)(_useState19, 1),
    term = _useState20[0];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useSuggestions = (0,build_esm.useSuggestions)({
      partnerId: partnerId
    }),
    suggestions = _useSuggestions.suggestions,
    productsSuggestions = _useSuggestions.productsSuggestions,
    getSuggestions = _useSuggestions.getSuggestions,
    cleanSuggestions = _useSuggestions.cleanSuggestions;
  var _useLocation = (0,build_esm.useLocation)(),
    locationData = _useLocation.location,
    error = _useLocation.error,
    getData = _useLocation.getData;
  var shouldUpdateZipcode = (0,utils_build_esm/* isZipcodeInvalid */.tl)(location);
  (0,react.useEffect)((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!((accountData == null ? void 0 : accountData.zip_code) && !location.zipCode || shouldUpdateZipcode)) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return getData({
            zipCode: shouldUpdateZipcode ? location.zipCode : accountData.zip_code
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  (0,react.useEffect)(function () {
    setHeaderProps(adaptMixerToStereoHeaderProps({
      config: config,
      data: data,
      location: location,
      staticProps: staticProps,
      structure: structure
    }));
  }, [JSON.stringify(location)]);
  (0,react.useEffect)(function () {
    if (!error && locationData.location && (!location.zipCode || shouldUpdateZipcode)) {
      var zipCode = shouldUpdateZipcode ? location.zipCode : accountData.zip_code;
      var updatedLocation = {
        zipCode: zipCode,
        zipCodeCity: locationData.location.city,
        zipCodeState: locationData.location.state
      };
      (0,utils_build_esm/* setLocationCookies */.Qf)(locationData.location, zipCode, structure, config);
      setHeaderProps(adaptMixerToStereoHeaderProps({
        config: config,
        data: data,
        location: updatedLocation,
        staticProps: staticProps,
        structure: structure
      }));
      publish('zipcode:auto', updatedLocation);
    }
  }, [error, JSON.stringify(locationData.location)]);
  var _useTopTerms = (0,build_esm.useTopTerms)(),
    _useTopTerms$topTerms = _useTopTerms.topTerms,
    _useTopTerms$topTerms2 = _useTopTerms$topTerms.label,
    topTermsLabel = _useTopTerms$topTerms2 === void 0 ? '' : _useTopTerms$topTerms2,
    _useTopTerms$topTerms3 = _useTopTerms$topTerms.terms,
    topTermsList = _useTopTerms$topTerms3 === void 0 ? [] : _useTopTerms$topTerms3;
  var topTermsProps = (0,utils_build_esm/* adaptUseTopTermsToStereoHeaderProps */.ac)({
    showTopTerms: showTopTerms,
    topTermsLabel: topTermsLabel,
    topTermsList: topTermsList
  });
  var suggestionsProps = adaptUseSuggestionsToStereoHeaderProps({
    products: productsSuggestions,
    terms: suggestions
  });
  var suggestionLinksProps = (0,react.useMemo)(function () {
    return structure.id === 'home' ? (0,commons/* parseHeaderLinksSuggestions */.D$)(linksSuggestionsData) : {};
  }, [structure.id]);
  var _useCart = (0,build_esm.useCart)(),
    _useCart2 = (0,slicedToArray/* default */.Z)(_useCart, 1),
    getCart = _useCart2[0].getCart;
  var _useWishlist = (0,build_esm.useWishlist)(),
    getWishlist = _useWishlist.getWishlist;
  var handleWishlistChange = function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2() {
      var _yield$getWishlist, wishlistData, wishlistError, _wishlistData$wishlis, hashId, storage, quantity;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (showWishlistCount) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return getWishlist(customerId);
          case 4:
            _yield$getWishlist = _context2.sent;
            wishlistData = _yield$getWishlist.data;
            wishlistError = _yield$getWishlist.error;
            if (!wishlistError) {
              hashId = customerId.slice(-4);
              storage = (0,utils_build_esm/* useStorage */.y$)('wishlist', hashId);
              storage.set(wishlistData.wishlist.items);
              quantity = wishlistData == null ? void 0 : (_wishlistData$wishlis = wishlistData.wishlist) == null ? void 0 : _wishlistData$wishlis.count;
              setWishlistCount(quantity);
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleWishlistChange() {
      return _ref6.apply(this, arguments);
    };
  }();
  var handleCartChange = function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee3() {
      var _yield$getCart, cartData, cartError, _cartData$cart, _cartData$cart$totals, quantity;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getCart(cartId, customerId);
          case 2:
            _yield$getCart = _context3.sent;
            cartData = _yield$getCart.data;
            cartError = _yield$getCart.error;
            if (!cartError) {
              quantity = parseInt((cartData == null ? void 0 : (_cartData$cart = cartData.cart) == null ? void 0 : (_cartData$cart$totals = _cartData$cart.totals) == null ? void 0 : _cartData$cart$totals.itemsQuantity) || 0, 10);
              setBagCount(quantity);
            }
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleCartChange() {
      return _ref7.apply(this, arguments);
    };
  }();
  var publishSuggestionFromRoute = function publishSuggestionFromRoute(suggestion) {
    var position = suggestions.findIndex(function (item) {
      return item.term === suggestion;
    }) + 1;
    publish('suggestion:click', {
      position: position,
      term: suggestion
    });
  };
  var handleZipcodeSuccess = function handleZipcodeSuccess() {
    publish('zipcodebar:popup:success');
    setShowZipcodePopper('success');
  };
  (0,react.useEffect)(function () {
    if (showZipcodePopper) {
      publish('zipcodebar:popup:view');
    }
  }, [showZipcodePopper]);
  (0,react.useEffect)(function () {
    if (cartId || customerId) {
      handleCartChange();
    }
    handleWishlistChange();
  }, []);
  (0,react.useEffect)(function () {
    if (suggestionLinksProps && structure.id === 'home') {
      publish('link-suggestions:impression', suggestionLinksProps);
    }
  }, [suggestionLinksProps]);
  (0,react.useEffect)(function () {
    subscribe('product:wishlist:click', handleWishlistChange);
    return function () {
      unsubscribe('product:wishlist:click', handleWishlistChange);
    };
  }, []);
  (0,react.useEffect)(function () {
    subscribe('zipcodebar:response:success', handleZipcodeSuccess);
    return function () {
      unsubscribe('zipcodebar:response:success', handleZipcodeSuccess);
    };
  });
  (0,react.useEffect)(function () {
    var _structure$route;
    if (chosenSuggestion && chosenSuggestion.includes(structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.term)) {
      var _structure$route2;
      publishSuggestionFromRoute(structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term);
    }
  }, [structure == null ? void 0 : (_structure$route3 = structure.route) == null ? void 0 : _structure$route3.term, chosenSuggestion]);
  (0,react.useEffect)(function () {
    return setTimeout(function () {
      return setShowZipcodePopper(headerProps.initialZipcodePopper);
    }, 2000);
  }, [headerProps]);
  (0,react.useEffect)(function () {
    setTimeout(function () {
      setIsRendered(true);
    }, 1000);
  }, []);
  var handleWishlistIconClick = function handleWishlistIconClick(e) {
    e.preventDefault();
    (0,utils_build_esm/* routePush */.dY)({
      path: wishlistUrl,
      spa: wishlistSpa
    });
  };
  var onLogoClick = function onLogoClick(e) {
    e.preventDefault();
    (0,utils_build_esm/* routePush */.dY)({
      path: headerData.logo.url,
      spa: headerData.logo.spa
    });
  };
  var handleSuggest = function handleSuggest(suggestionsTerm, productsSize) {
    getSuggestions({
      productsSize: productsSize,
      term: suggestionsTerm
    });
  };
  var handleSuggestDebounced = debounce_default()(function (suggestion) {
    return handleSuggest(suggestion, 5);
  }, 500);
  var handleSuggestThrottled = throttle_default()(function (suggestion) {
    var productsSize = suggestion.endsWith(' ') ? 5 : 0;
    return handleSuggest(suggestion, productsSize);
  }, 500);
  var handleSuggestionClick = function handleSuggestionClick(suggestion) {
    setChosenSuggestion(suggestion);
  };
  var handleTopTermItemClick = function handleTopTermItemClick(topTerm) {
    setShowTopTerms(false);
    var position = topTerm.index,
      clickedTopTerm = topTerm.term;
    publish('suggestion:topterm:click', {
      position: position,
      term: clickedTopTerm
    });
  };
  var handleProductItemClick = function handleProductItemClick(e, product) {
    e.preventDefault();
    var id = product.id,
      path = product.path;
    var position = productsSuggestions.findIndex(function (item) {
      return item.variationId === id;
    }) + 1;
    publish('suggestion-product:click', {
      position: position,
      variationId: id
    });
    (0,utils_build_esm/* routePush */.dY)({
      path: path,
      spa: headerData.suggestions.spa
    });
  };
  var handleSearch = function handleSearch(e, newTerm) {
    e.preventDefault();
    var newTermTrim = newTerm.trim();
    if (e.type === 'submit' && newTermTrim) {
      publish('search:submit', {
        term: newTermTrim
      });
    }
    var replacedTerm = newTermTrim.replace(/[*=_#%¨()|\\/|!:@]/g, ' ');
    var termStr = replacedTerm && "".concat((0,structure_build_esm/* termToUrl */.Bl)((0,utils_build_esm/* slug */.oF)(replacedTerm)), "/");
    var newTermUrl = "".concat(searchUrl.replace(/\/?$/, '/')).concat(termStr);
    (0,utils_build_esm/* routePush */.dY)({
      path: newTermUrl,
      spa: true
    });
  };
  var handleTypeSearch = function handleTypeSearch(newTerm) {
    setCurrentTerm(newTerm);
    if (newTerm.length === 0) {
      cleanSuggestions();
      setShowTopTerms(true);
    }
    if (newTerm.length >= 2) {
      setShowTopTerms(false);
      if (newTerm.length < 5 || newTerm.endsWith(' ')) {
        handleSuggestThrottled(newTerm);
      } else {
        handleSuggestDebounced(newTerm);
      }
    }
  };
  var handleOpenInput = function handleOpenInput() {
    if (currentTerm.trim()) {
      setShowTopTerms(false);
      if (suggestions.length === 0) {
        handleSuggest(term);
      }
    } else {
      setShowTopTerms(true);
    }
  };
  var handlePopperBtn = function handlePopperBtn() {
    setShowZipcodePopper(null);
    publish('zipcodebar:popup:click');
    publish('zipcodeinput:toggle');
  };
  var handleClosePopper = function handleClosePopper() {
    if (showZipcodePopper === 'info') {
      publish('addtorejectzipcode:success');
      publish('zipcodebar:popup:close');
    }
    setShowZipcodePopper(null);
  };
  var handleCloseInput = function handleCloseInput() {
    setShowTopTerms(false);
    publish('search:close', {
      term: term
    });
  };
  var wishlistProps = (0,esm_extends/* default */.Z)({
    amount: wishlistCount,
    nullable: showWishlistCount,
    onClick: handleWishlistIconClick
  }, wishListIconProps);
  headerProps.data.wishlist = wishlistProps;
  var handleMenuItemClick = function handleMenuItemClick(e, link, selectedSubmenu, menuType) {
    e.preventDefault();
    publish('product:selectContent', selectedSubmenu, link.label, menuType);
    (0,utils_build_esm/* routePush */.dY)({
      path: link == null ? void 0 : link.url,
      spa: true
    });
  };
  var handleClickLinks = function handleClickLinks(label) {
    publish(HEADER_SELECT_CONTENT, label);
  };
  var handleClickSearch = function handleClickSearch() {
    publish(HEADER_SELECT_CONTENT, currentTerm, 'search');
  };
  var handleUnsignedClick = function handleUnsignedClick() {
    publish(HEADER_SELECT_CONTENT, 'cadastro');
  };
  var handleSignedHover = function handleSignedHover() {
    publish(HEADER_IMPRESSION, 'login');
  };
  var handleClickLinkSuggestion = function handleClickLinkSuggestion(e, link) {
    e.preventDefault();
    publish('link-suggestions:click', link);
    publish(HEADER_SELECT_CONTENT, link.value, 'suggestion');
    (0,utils_build_esm/* routePush */.dY)({
      path: link.href,
      spa: true
    });
  };
  var handleZipCodeClick = function handleZipCodeClick() {
    setShowZipcodePopper(null);
    publish(HEADER_SELECT_CONTENT, 'ver-ofertas-para-minha-regiao');
    publish('zipcodeinput:toggle');
  };
  var handleSignedMenuClick = function handleSignedMenuClick(label) {
    publish(HEADER_SELECT_CONTENT, label, 'login');
  };
  var handleHoverZipCode = function handleHoverZipCode() {
    seIsHoverZipcode(true);
    if (!isHoverZipcode) publish(HEADER_IMPRESSION, 'ver-ofertas-para-minha-regiao');
  };
  var handleClickWishlist = function handleClickWishlist() {
    publish(HEADER_SELECT_CONTENT, 'favoritos');
  };
  var handleClickBag = function handleClickBag() {
    publish(HEADER_SELECT_CONTENT, 'sacola');
    window.location.assign(cartUrl);
  };
  var handleHoverMenuItem = function handleHoverMenuItem(menu) {
    publish(HEADER_IMPRESSION, menu.label);
  };
  var handleClickMenuItem = function handleClickMenuItem(label) {
    publish(HEADER_SELECT_CONTENT, label, 'menu');
  };
  var bagProps = (0,esm_extends/* default */.Z)({
    amount: bagCount,
    onClick: handleClickBag
  }, bagIconProps);
  headerProps.data.bag = bagProps;
  return react.createElement(Container, null, react.createElement(HeaderDesktop/* default */.Z, (0,esm_extends/* default */.Z)({}, headerProps, suggestionsProps, topTermsProps, suggestionLinksProps, {
    customLoginMenu: HeaderDesktop_renderCustomLoginMenu(customLoginMenu == null ? void 0 : customLoginMenu.component, {
      customLoginMenu: customLoginMenu,
      structure: structure
    }),
    onLogoClick: onLogoClick,
    initialValue: term,
    isRendered: isRendered,
    onSuggestItemClick: handleSuggestionClick,
    onProductItemClick: handleProductItemClick,
    onTopTermItemClick: handleTopTermItemClick,
    onHeaderSuggestionLinkClick: handleClickLinkSuggestion,
    onInputOpen: handleOpenInput,
    onInputClose: handleCloseInput,
    onSearch: handleSearch,
    onTypeSearch: handleTypeSearch,
    onZipCodeClick: handleZipCodeClick,
    onClickPopperBtn: handlePopperBtn,
    onClosePopper: handleClosePopper,
    onHorizontalLinksClick: handleClickLinks,
    onClickSearchEvent: handleClickSearch,
    onUnsignedClick: handleUnsignedClick,
    onSignedHover: handleSignedHover,
    popperDisplay: showZipcodePopper,
    onMenuItemClick: handleMenuItemClick,
    onSignedMenuClick: handleSignedMenuClick,
    onHoverZipCode: handleHoverZipCode,
    onClickWishlist: handleClickWishlist,
    onHoverMenuItem: handleHoverMenuItem,
    onClickMenuItem: handleClickMenuItem
  })));
}
 false ? 0 : void 0;
HeaderDesktop_HeaderDesktop.defaultProps = {
  config: {},
  data: {},
  "static": {},
  structure: {
    cookies: {},
    route: {}
  }
};
HeaderDesktop_HeaderDesktop.ssr = true;
HeaderDesktop_HeaderDesktop.displayName = 'HeaderDesktop';
HeaderDesktop_HeaderDesktop.dataSource = {
  categories: {
    query: 'AllCategoriesQuery'
  },
  channel: {
    query: 'ChannelQuery'
  }
};
/* harmony default export */ var ecommerce_HeaderDesktop_HeaderDesktop = ((0,withLayoutProps/* default */.Z)(HeaderDesktop_HeaderDesktop));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktop/index.js


/***/ }),

/***/ 9404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HeaderDesktopPMD_HeaderDesktopPMD; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ShoppingBagButton/index.js + 2 modules
var ShoppingBagButton = __webpack_require__(15185);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/index.js + 10 modules
var SearchInput = __webpack_require__(37222);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 39 modules
var structure_build_esm = __webpack_require__(48728);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LogoParceiroMagalu/index.js + 2 modules
var LogoParceiroMagalu = __webpack_require__(23076);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/Profile/Profile.styles.js

var _templateObject, _templateObject2, _templateObject3;


var Container = styled_components_browser_esm["default"].a(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-decoration: none;\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row;\n  margin-right: 25px;\n  background-color: transparent;\n  border: none;\n  align-items: center;\n  cursor: pointer;\n  margin-left: 7px;\n\n  &:focus {\n    outline: 5px auto Highlight;\n    outline: 5px auto -webkit-focus-ring-color;\n  }\n"])));
var Logo = styled_components_browser_esm["default"].div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  & > div {\n    justify-content: center;\n    align-items: flex-start;\n    height: 100%;\n    & > span {\n      margin-bottom: 8px;\n    }\n  }\n"])));
var ProfileImage = styled_components_browser_esm["default"].img(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  margin-right: 20px;\n  display: none;\n\n  ", " {\n    display: block;\n  }\n"])), (0,stereo_ui_styles_build_esm.getMediaQuery)('small'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/Profile/Profile.js




function Profile(_ref) {
  var store = _ref.store;
  var lowerStoreName = (store.name || '').toLowerCase();
  return react.createElement(Container, {
    href: "/magazine".concat(lowerStoreName),
    "data-testid": "header-profile-button"
  }, store.image ? react.createElement(ProfileImage, {
    src: "".concat(store.image, "?width=70&height=70"),
    alt: "Imagem da loja magazine".concat(lowerStoreName)
  }) : null, react.createElement(Logo, null, react.createElement(LogoParceiroMagalu/* default */.Z, {
    name: lowerStoreName
  })));
}
 false ? 0 : void 0;
Profile.defaultProps = {
  store: {
    image: null,
    name: ''
  }
};
/* harmony default export */ var Profile_Profile = (Profile);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/Profile/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/Loyalty/Loyalty.styles.js

var Loyalty_styles_templateObject, Loyalty_styles_templateObject2, Loyalty_styles_templateObject3, _templateObject4;


var Alert = styled_components_browser_esm["default"].div(Loyalty_styles_templateObject || (Loyalty_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: none;\n  position: absolute;\n  top: 60px;\n  z-index: 2;\n  background-color: ", ";\n  border-radius: 5px;\n  font-size: ", "px;\n  line-height: 40px;\n  color: #999;\n  text-align: center;\n  word-break: keep-all;\n  padding: 0 15px;\n  white-space: nowrap;\n  left: 50%;\n  transform: translate(-50%);\n\n  & span {\n    color: ", ";\n  }\n\n  &:after {\n    content: '';\n    display: inline-block;\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid ", ";\n    position: absolute;\n    top: -6px;\n    left: 50%;\n    transform: translate(-50%);\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('colors.white'), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.1'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.base'), (0,stereo_ui_styles_build_esm.themeGet)('colors.white'));
var Background = styled_components_browser_esm["default"].div(Loyalty_styles_templateObject2 || (Loyalty_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 100%;\n\n  & div {\n    position: absolute;\n    width: 40px;\n    height: 100%;\n    left: 50%;\n    transform: translate(-50%);\n    background-color: ", ";\n    z-index: 0;\n\n    &:after {\n      content: '';\n      display: inline-block;\n      width: 0;\n      height: 0;\n      border-left: 20px solid ", ";\n      border-right: 20px solid ", ";\n      border-top: 14px solid ", ";\n      position: absolute;\n      bottom: 0;\n    }\n  }\n\n  & hr {\n    top: -2px;\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n    border-radius: 50%;\n    border: 2px solid transparent;\n    border-bottom: 3px solid #33333355;\n  }\n"])), (0,stereo_ui_styles_build_esm.getPaletteColor)('background.loyalty'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.base'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.base'), (0,stereo_ui_styles_build_esm.getPaletteColor)('background.loyalty'));
var Badge = styled_components_browser_esm["default"].img(Loyalty_styles_templateObject3 || (Loyalty_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 6px;\n  left: 50%;\n  transform: translate(-50%);\n  z-index: 2;\n"])));
var Loyalty_styles_Container = styled_components_browser_esm["default"].div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: none;\n  flex: 0 0 auto;\n  width: ", ";\n  height: ", ";\n  position: relative;\n  margin-right: ", ";\n\n  &:focus ", " {\n    display: block;\n  }\n\n  &:hover ", " {\n    display: block;\n  }\n\n  ", " {\n    display: block;\n  }\n"])), function (_ref) {
  var isInfluencer = _ref.isInfluencer;
  return isInfluencer ? '42px' : '79px';
}, function (_ref2) {
  var isInfluencer = _ref2.isInfluencer;
  return isInfluencer ? '60px' : '51px';
}, function (_ref3) {
  var isInfluencer = _ref3.isInfluencer;
  return isInfluencer ? '35px' : '22px';
}, Alert, Alert, (0,stereo_ui_styles_build_esm.getMediaQuery)('medium'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/Loyalty/Loyalty.js



function Loyalty(_ref) {
  var loyalty = _ref.loyalty;
  var slug = loyalty.slug,
    title = loyalty.title,
    isInfluencer = loyalty.isInfluencer;
  if (!slug || !title) {
    return null;
  }
  return react.createElement(Loyalty_styles_Container, {
    tabIndex: "0",
    isInfluencer: isInfluencer
  }, react.createElement(Badge, {
    src: "https://mvc.mlcdn.com.br/magazinevoce/img/badges/badge_".concat(isInfluencer ? 'influencer' : slug, ".png"),
    alt: "Imagem da loja"
  }), !isInfluencer && react.createElement(Background, null, react.createElement("hr", null), react.createElement("div", null)), react.createElement(Alert, null, 'Esta é uma loja de nível ', react.createElement("span", null, isInfluencer ? 'Influenciador' : title)));
}
 false ? 0 : void 0;
Loyalty.defaultProps = {
  loyalty: {
    isInfluencer: false,
    slug: 'beginner',
    title: 'Novato'
  }
};
/* harmony default export */ var Loyalty_Loyalty = (Loyalty);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/Loyalty/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/Categories/Categories.styles.js

var Categories_styles_templateObject, Categories_styles_templateObject2, Categories_styles_templateObject3, Categories_styles_templateObject4, _templateObject5, _templateObject6;


var AllDepartments = styled_components_browser_esm["default"].button(Categories_styles_templateObject || (Categories_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 5px 0 0 0;\n  background-color: ", ";\n  padding: 8px 12px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: none;\n  color: ", ";\n  fill: ", ";\n\n  & span {\n    font-weight: ", ";\n    margin: 0 10px 0 15px;\n    font-size: ", "px;\n  }\n  &:focus,\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    fill: ", ";\n  }\n"])), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.lightest'), (0,stereo_ui_styles_build_esm.getTextColor)('lightest'), (0,stereo_ui_styles_build_esm.getTextColor)('lightest'), (0,stereo_ui_styles_build_esm.themeGet)('fontWeight.bold'), (0,stereo_ui_styles_build_esm.getFontSize)(1), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmdLight.base'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmdLight.text'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmdLight.text'));
var Categories_styles_Container = styled_components_browser_esm["default"].div(Categories_styles_templateObject2 || (Categories_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  height: 40px;\n"])));
var MainCategory = styled_components_browser_esm["default"].a(Categories_styles_templateObject3 || (Categories_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-decoration: none;\n  font-size: ", "px;\n  padding: 12px 14px;\n  height: 40px;\n  display: inline-block;\n  cursor: pointer;\n  color: ", ";\n  &:focus,\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), (0,stereo_ui_styles_build_esm.getFontSize)(1), (0,stereo_ui_styles_build_esm.getTextColor)('lightest'), (0,stereo_ui_styles_build_esm.getBackgroundColor)('lighter'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.dark'));
var MainMenu = styled_components_browser_esm["default"].ul(Categories_styles_templateObject4 || (Categories_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  height: 40px;\n  display: flex;\n  flex-wrap: wrap;\n  overflow: hidden;\n  border-radius: 5px 5px 0 0;\n  color: ", ";\n\n  li {\n    list-style: none;\n  }\n"])), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.light'), (0,stereo_ui_styles_build_esm.getTextColor)('lightest'));
var SubCategory = styled_components_browser_esm["default"].a(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-decoration: none;\n  line-height: 20px;\n  display: inline-block;\n  padding: 5px;\n  color: ", ";\n  font-size: ", "px;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), (0,stereo_ui_styles_build_esm.getTextColor)('scratched'), (0,stereo_ui_styles_build_esm.getFontSize)(1));
var SubMenu = styled_components_browser_esm["default"].ul(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: ", ";\n  visibility: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-top: 0;\n  border-bottom: 4px solid ", ";\n  border-radius: 0 0 5px 5px;\n  padding: 20px 25px;\n  grid-column-gap: 35px;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  &:hover {\n    display: grid;\n  }\n\n  li {\n    list-style: none;\n  }\n"])), function (_ref) {
  var display = _ref.display;
  return display ? 'grid' : 'none';
}, function (_ref2) {
  var display = _ref2.display;
  return display ? 'visible' : 'hidden';
}, (0,stereo_ui_styles_build_esm.getBackgroundColor)('lighter'), (0,stereo_ui_styles_build_esm.themeGet)('borders.0'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.base'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/Categories/Categories.js





function Categories(_ref) {
  var highlighted = _ref.highlighted,
    allCategories = _ref.allCategories,
    storeName = _ref.storeName;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showSubMenu = _useState2[0],
    setShowSubMenu = _useState2[1];
  var lowerStoreName = (storeName || '').toLowerCase();
  return react.createElement(Categories_styles_Container, null, react.createElement(MainMenu, null, react.createElement("li", null, react.createElement(AllDepartments, {
    onMouseEnter: function onMouseEnter() {
      return setShowSubMenu(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowSubMenu(false);
    },
    onClick: function onClick() {
      return setShowSubMenu(function (previousState) {
        return !previousState;
      });
    },
    "aria-expanded": showSubMenu,
    "data-testid": "categories-alldepartments"
  }, react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
    name: "Burger"
  }), react.createElement("span", null, "Todos os departamentos"), react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
    name: "ChevronDown"
  }))), highlighted.map(function (highlight) {
    return react.createElement("li", {
      key: highlight.id
    }, react.createElement(MainCategory, {
      href: "/magazine".concat(lowerStoreName, "/").concat(highlight.slug, "/l/").concat(highlight.id_ml.toLowerCase())
    }, highlight.name));
  })), react.createElement(SubMenu, {
    display: showSubMenu,
    "data-testid": "categories-submenu"
  }, allCategories.map(function (category) {
    return react.createElement("li", {
      key: category.id
    }, react.createElement(SubCategory, {
      href: category.meta.canonical
    }, category.description));
  })));
}
 false ? 0 : void 0;
Categories.defaultProps = {
  allCategories: [],
  highlighted: []
};
/* harmony default export */ var Categories_Categories = (Categories);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/Categories/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/MenuItem/index.js + 2 modules
var MenuItem = __webpack_require__(54934);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/index.js
var stereo_ui_build_esm = __webpack_require__(87302);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/LoggedMenu/LoggedMenu.styles.js

var LoggedMenu_styles_templateObject, LoggedMenu_styles_templateObject2, LoggedMenu_styles_templateObject3;


var LoggedMenu_styles_Container = styled_components_browser_esm["default"].div(LoggedMenu_styles_templateObject || (LoggedMenu_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 20px;\n  position: relative;\n  & button {\n    width: 165px;\n    &:focus {\n      outline: 5px auto Highlight;\n      outline: 5px auto -webkit-focus-ring-color;\n    }\n    & > label {\n      font-weight: ", ";\n    }\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('fontWeight.regular'));
var Loggout = styled_components_browser_esm["default"].a(LoggedMenu_styles_templateObject2 || (LoggedMenu_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  padding: 12px;\n  font-size: ", "px;\n  cursor: pointer;\n  color: ", ";\n\n  & span {\n    text-decoration: underline;\n  }\n\n  &:hover {\n    color: ", ";\n  }\n"])), (0,stereo_ui_styles_build_esm.getFontSize)(1), (0,stereo_ui_styles_build_esm.getTextColor)('scratched'), (0,stereo_ui_styles_build_esm.themeGet)('palette.pmd.base'));
var Menu = styled_components_browser_esm["default"].div(LoggedMenu_styles_templateObject3 || (LoggedMenu_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: ", ";\n  position: absolute;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  color: ", ";\n  margin-top: 2px;\n  width: 200px;\n\n  & > div {\n    cursor: pointer;\n  }\n\n  & svg {\n    fill: ", ";\n    color: ", ";\n  }\n\n  & a {\n    color: ", ";\n    text-decoration: none;\n  }\n\n  & a:hover a {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), function (_ref) {
  var display = _ref.display;
  return display ? 'block' : 'none';
}, (0,stereo_ui_styles_build_esm.getBackgroundColor)('lighter'), (0,stereo_ui_styles_build_esm.themeGet)('borders.0'), (0,stereo_ui_styles_build_esm.themeGet)('radii.default'), (0,stereo_ui_styles_build_esm.getTextColor)('scratched'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.dark'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.dark'), (0,stereo_ui_styles_build_esm.getTextColor)('scratched'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.base'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/LoggedMenu/LoggedMenu.js







function LoggedMenu(_ref) {
  var data = _ref.data,
    isPromoter = _ref.isPromoter,
    userName = _ref.userName;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showMenuButton = _useState2[0],
    setShowMenuButton = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    showMenu = _useState4[0],
    setShowMenu = _useState4[1];
  var _useState5 = (0,react.useState)([]),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    menuList = _useState6[0],
    setMenuList = _useState6[1];
  (0,react.useEffect)(function () {
    var items = data.menuItems.filter(function (item) {
      return (isPromoter && data.promoterMenu || data.clientMenu).includes(item.id);
    });
    setMenuList(items);
  }, [isPromoter]);
  var menuRef = (0,react.useRef)();
  (0,stereo_ui_build_esm/* useOnClickOutside */.t$X)(menuRef, function () {
    setShowMenu(false);
  });
  (0,react.useEffect)(function () {
    setShowMenuButton(true);
  }, []);
  return react.createElement(LoggedMenu_styles_Container, null, showMenuButton && react.createElement(Button/* default */.Z, {
    variation: "outline",
    customColor: {
      "default": '#fff',
      hover: '#fff'
    },
    size: "medium",
    endIcon: "ChevronDown",
    centered: true,
    uppercase: false,
    onClick: function onClick() {
      return setShowMenu(!showMenu);
    },
    "data-testid": "loggedmenu-openmenu-button"
  }, react.createElement("p", null, "Seu espa\xE7o")), react.createElement(Menu, {
    display: showMenu,
    ref: menuRef,
    "data-testid": "loggedmenu-menu"
  }, menuList.map(function (item) {
    return react.createElement(MenuItem/* default */.Z, {
      key: item.id,
      icon: item.icon,
      text: item.text,
      chevronRight: false,
      as: "a",
      href: item.newHref ? item.newHref : item.href,
      "data-testid": "loggedmenu-menu".concat(item.id, "-button")
    });
  }), react.createElement(Loggout, {
    href: data.logoutUrl
  }, userName && "N\xE3o \xE9 ".concat(userName.split(' ')[0], "? "), react.createElement("span", null, "Sair"))));
}
 false ? 0 : void 0;
LoggedMenu.defaultProps = {
  isPromoter: false,
  userName: ''
};
/* harmony default export */ var LoggedMenu_LoggedMenu = (LoggedMenu);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/LoggedMenu/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/LogInMenu/LogInMenu.styles.js


var LogInMenu_styles_templateObject, LogInMenu_styles_templateObject2, LogInMenu_styles_templateObject3, LogInMenu_styles_templateObject4, LogInMenu_styles_templateObject5, LogInMenu_styles_templateObject6, _templateObject7, _templateObject8;



var ButtonContainer = styled_components_browser_esm["default"].div(LogInMenu_styles_templateObject || (LogInMenu_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-bottom: 4px;\n  & button {\n    width: 140px;\n    & > label {\n      font-weight: ", ";\n    }\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('fontWeight.regular'));
var LogInMenu_styles_Container = styled_components_browser_esm["default"].div(LogInMenu_styles_templateObject2 || (LogInMenu_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 30px;\n  display: flex;\n"])));
var Content = styled_components_browser_esm["default"].div(LogInMenu_styles_templateObject3 || (LogInMenu_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  color: ", ";\n  line-height: 20px;\n\n  & > button {\n    padding: 0;\n    display: flex;\n  }\n"])), (0,stereo_ui_styles_build_esm.getFontSize)(1), (0,stereo_ui_styles_build_esm.getTextColor)('lightest'));
var LogInMenu_styles_Menu = styled_components_browser_esm["default"].div(LogInMenu_styles_templateObject4 || (LogInMenu_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: ", ";\n  position: absolute;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  margin-top: 2px;\n  padding: 10px;\n  padding-bottom: 0;\n\n  & a {\n    cursor: pointer;\n    text-align: center;\n    font-size: ", "px;\n    color: ", ";\n    background: ", ";\n    text-decoration: none;\n    width: 100%;\n    display: inline-block;\n    padding-bottom: 10px;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (_ref) {
  var display = _ref.display;
  return display ? 'block' : 'none';
}, (0,stereo_ui_styles_build_esm.getBackgroundColor)('lighter'), (0,stereo_ui_styles_build_esm.themeGet)('borders.0'), (0,stereo_ui_styles_build_esm.themeGet)('radii.default'), (0,stereo_ui_styles_build_esm.getFontSize)(1), (0,stereo_ui_styles_build_esm.getTextColor)('light'), (0,stereo_ui_styles_build_esm.getBackgroundColor)('lighter'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.base'));
var NewButtonContainer = styled_components_browser_esm["default"].div(LogInMenu_styles_templateObject5 || (LogInMenu_styles_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  & button {\n    width: 200px;\n    margin-bottom: 8px;\n    & > label {\n      font-weight: ", ";\n    }\n  }\n\n  & hr {\n    border: 0;\n    border-top: 1px solid #eeeeee;\n    margin: 10px 0 5px 0;\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('fontWeight.regular'));
var PackagesContainer = styled_components_browser_esm["default"].div(LogInMenu_styles_templateObject6 || (LogInMenu_styles_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-top: ", ";\n\n  & div {\n    padding-left: 4px;\n    cursor: pointer;\n  }\n\n  & svg {\n    fill: ", ";\n    color: ", ";\n  }\n\n  & p {\n    color: ", ";\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('borders.0'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.dark'), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.dark'), (0,stereo_ui_styles_build_esm.getTextColor)('scratched'));
var StyledLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: '#fff'
  }, props);
})(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var UserImage = styled_components_browser_esm["default"].img(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 47px;\n  width: 47px;\n  margin-right: 10px;\n  background-color: ", ";\n  border-radius: 100%;\n"])), (0,stereo_ui_styles_build_esm.getPaletteColor)('pmd.dark'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/LogInMenu/LogInMenu.js









function LogInMenu(_ref) {
  var data = _ref.data,
    theme = _ref.theme;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showMenu = _useState2[0],
    setShowMenu = _useState2[1];
  var menuRef = (0,react.useRef)();
  (0,stereo_ui_build_esm/* useOnClickOutside */.t$X)(menuRef, function () {
    setShowMenu(false);
  });
  return react.createElement(LogInMenu_styles_Container, null, react.createElement(UserImage, {
    src: "https://mvc.mlcdn.com.br/magazinevoce/img/common/person.svg?1654521562"
  }), react.createElement(Content, null, react.createElement("strong", null, "Bem vindo :)"), react.createElement(StyledLink, {
    onClick: function onClick() {
      return setShowMenu(!showMenu);
    },
    "data-testid": "loginmenu-openmenu-button"
  }, "Entre ou cadastre-se", react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
    color: "#fff",
    name: "ChevronDown"
  })), react.createElement(LogInMenu_styles_Menu, {
    display: showMenu,
    ref: menuRef,
    "data-testid": "loginmenu-menu"
  }, react.createElement(NewButtonContainer, null, react.createElement(Button/* default */.Z, {
    variation: "primary",
    customColor: {
      "default": theme == null ? void 0 : theme.palette.pmd.light,
      hover: theme == null ? void 0 : theme.palette.pmd.light
    },
    size: "medium",
    uppercase: false,
    onClick: function onClick() {
      return (0,build_esm/* routePush */.dY)({
        path: data.nationalUrl
      });
    },
    "data-testid": "loginmenu-client-button"
  }, "Entrar como cliente"), react.createElement(Button/* default */.Z, {
    variation: "outline",
    customColor: {
      "default": theme == null ? void 0 : theme.palette.pmd.light,
      hover: theme == null ? void 0 : theme.palette.pmd.light
    },
    size: "medium",
    uppercase: false,
    onClick: function onClick() {
      return (0,build_esm/* routePush */.dY)({
        path: data.promoterUrl
      });
    },
    "data-testid": "loginmenu-promoter-button"
  }, "Entrar como influenciador"), react.createElement("hr", null)), react.createElement("a", {
    href: data.nationalUrl
  }, "ou cadastre-se"), react.createElement(PackagesContainer, null, react.createElement(MenuItem/* default */.Z, {
    icon: "Package",
    text: "Meus pedidos",
    chevronRight: false,
    noBorder: true,
    onClick: function onClick() {
      return (0,build_esm/* routePush */.dY)({
        path: data.packageUrl
      });
    },
    "data-testid": "loginmenu-package-button"
  })))));
}
 false ? 0 : void 0;
LogInMenu.defaultProps = {};
/* harmony default export */ var LogInMenu_LogInMenu = (LogInMenu);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/components/LogInMenu/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/HeaderDesktopPMD.styles.js

var HeaderDesktopPMD_styles_templateObject, HeaderDesktopPMD_styles_templateObject2, HeaderDesktopPMD_styles_templateObject3, HeaderDesktopPMD_styles_templateObject4, HeaderDesktopPMD_styles_templateObject5, HeaderDesktopPMD_styles_templateObject6;


var Cart = styled_components_browser_esm["default"].div(HeaderDesktopPMD_styles_templateObject || (HeaderDesktopPMD_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 0 0 45px;\n  transform: scale(0.65);\n\n  & svg:focus {\n    outline: 5px auto Highlight;\n    outline: 5px auto -webkit-focus-ring-color;\n  }\n"])));
var CategoriesContainer = styled_components_browser_esm["default"].div(HeaderDesktopPMD_styles_templateObject2 || (HeaderDesktopPMD_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-column: 2 / 3;\n  grid-row: 2 / 3;\n  z-index: 5;\n"])));
var Header = styled_components_browser_esm["default"].header(HeaderDesktopPMD_styles_templateObject3 || (HeaderDesktopPMD_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-decoration: none;\n  width: 100%;\n  background-color: ", ";\n  display: grid;\n  grid-template-columns: 1fr minmax(auto, 1366px) 1fr;\n  grid-template-rows: 90px 40px;\n"])), (0,stereo_ui_styles_build_esm.themeGet)('palette.pmd.base'));
var Main = styled_components_browser_esm["default"].div(HeaderDesktopPMD_styles_templateObject4 || (HeaderDesktopPMD_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  grid-column: 2 / 3;\n  grid-row: 1 / 2;\n  z-index: 6;\n"])));
var Search = styled_components_browser_esm["default"].div(HeaderDesktopPMD_styles_templateObject5 || (HeaderDesktopPMD_styles_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 0 1 330px;\n  min-width: 160px;\n  margin-right: 22px;\n\n  svg:focus {\n    outline: 5px auto Highlight;\n    outline: 5px auto -webkit-focus-ring-color;\n  }\n\n  & > div {\n    border: none;\n    & > div:first-child {\n      border: none;\n      height: 40px;\n    }\n    & > div:nth-child(2) {\n      border: ", ";\n      border-radius: ", ";\n      top: 43px;\n    }\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('borders.0'), (0,stereo_ui_styles_build_esm.themeGet)('radii.default'));
var Space = styled_components_browser_esm["default"].div(HeaderDesktopPMD_styles_templateObject6 || (HeaderDesktopPMD_styles_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 20px;\n  flex: 1 1 0px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/HeaderDesktopPMD.js
















function HeaderDesktopPMD(_ref) {
  var _staticProps$menuData, _staticProps$menuData2, _staticProps$menuData3, _structure$route4;
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var allCategories = data.allCategories;
  var cookies = structure.cookies,
    _structure$route = structure.route,
    route = _structure$route === void 0 ? {} : _structure$route;
  var _staticProps$loggedMe = staticProps.loggedMenu,
    loggedMenu = _staticProps$loggedMe === void 0 ? {} : _staticProps$loggedMe,
    _staticProps$logInMen = staticProps.logInMenu,
    logInMenu = _staticProps$logInMen === void 0 ? {} : _staticProps$logInMen,
    _staticProps$store = staticProps.store,
    store = _staticProps$store === void 0 ? {} : _staticProps$store,
    _staticProps$loyalty = staticProps.loyalty,
    loyalty = _staticProps$loyalty === void 0 ? {} : _staticProps$loyalty;
  var userData = cookies.promoterData || cookies.accountData;
  var isLogged = userData || false;
  var isPromoter = isLogged && structure.cookies.promoterData;
  var highlighted = staticProps == null ? void 0 : (_staticProps$menuData = staticProps.menuData) == null ? void 0 : (_staticProps$menuData2 = _staticProps$menuData.data) == null ? void 0 : (_staticProps$menuData3 = _staticProps$menuData2.categoryList) == null ? void 0 : _staticProps$menuData3.highlighted;
  var partnerId = cookies.partnerId;
  var _useSuggestions = (0,esm.useSuggestions)({
      partnerId: partnerId
    }),
    suggestions = _useSuggestions.suggestions,
    getSuggestions = _useSuggestions.getSuggestions;
  var _route$term = route.term,
    initialQuery = _route$term === void 0 ? '' : _route$term;
  var _useState = (0,react.useState)(initialQuery),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    term = _useState2[0],
    setTerm = _useState2[1];
  var _useState3 = (0,react.useState)(),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    chosenSuggestion = _useState4[0],
    setChosenSuggestion = _useState4[1];
  var publishSuggestionFromRoute = function publishSuggestionFromRoute(suggestion) {
    var position = suggestions.findIndex(function (item) {
      return item.term === suggestion;
    }) + 1;
    publish('suggestion:click', {
      position: position,
      term: suggestion
    });
  };
  (0,react.useEffect)(function () {
    var _structure$route2;
    if (chosenSuggestion && (chosenSuggestion == null ? void 0 : chosenSuggestion.includes(structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term))) {
      var _structure$route3;
      publishSuggestionFromRoute(structure == null ? void 0 : (_structure$route3 = structure.route) == null ? void 0 : _structure$route3.term);
    }
  }, [structure == null ? void 0 : (_structure$route4 = structure.route) == null ? void 0 : _structure$route4.term, chosenSuggestion]);
  var onSearch = function onSearch(e, newTerm) {
    e.preventDefault();
    var newTermTrim = newTerm.trim();
    if (e.type === 'submit' && newTermTrim) {
      publish('search:submit', {
        term: newTermTrim
      });
    }
    var termStr = newTermTrim ? "".concat((0,structure_build_esm/* termToUrl */.Bl)((0,build_esm/* slug */.oF)(newTermTrim)), "/") : '';
    var newTermUrl = "".concat(staticProps.searchUrl).concat(termStr);
    (0,build_esm/* routePush */.dY)({
      path: newTermUrl,
      spa: true
    });
  };
  var handleSuggest = function handleSuggest(suggestionsTerm) {
    getSuggestions({
      term: suggestionsTerm
    });
  };
  var handleSuggestionClick = function handleSuggestionClick(suggestion) {
    setChosenSuggestion(suggestion);
  };
  var onOpenInput = function onOpenInput() {
    if (term.trim() && !suggestions.length) {
      handleSuggest(term);
    }
  };
  var handleTermTypeChange = function handleTermTypeChange(newTerm) {
    setTerm(newTerm);
    handleSuggest(newTerm);
  };
  return react.createElement(Header, null, react.createElement(Main, null, react.createElement(Profile_Profile, {
    store: store
  }), react.createElement(Loyalty_Loyalty, {
    loyalty: loyalty,
    isInfluencer: loyalty == null ? void 0 : loyalty.isInfluencer
  }), react.createElement(Search, null, react.createElement(SearchInput/* default */.Z, {
    desktopMode: true,
    placeholder: "Procure por c\xF3digo, nome, marca...",
    onSearch: onSearch,
    onSuggestItemClick: handleSuggestionClick,
    onTypeChange: handleTermTypeChange,
    onInputOpen: onOpenInput,
    initialValue: term,
    list: suggestions,
    autoFocus: true
  })), react.createElement(Space, null), isLogged ? react.createElement(LoggedMenu_LoggedMenu, {
    data: loggedMenu,
    isPromoter: isPromoter,
    userName: userData.name
  }) : react.createElement(LogInMenu_LogInMenu, {
    data: logInMenu,
    theme: structure == null ? void 0 : structure.theme
  }), react.createElement(Cart, {
    "data-testid": "header-shopping-button"
  }, react.createElement(ShoppingBagButton/* default */.Z, {
    nullable: false,
    amount: 0,
    onClick: function onClick() {
      return (0,build_esm/* routePush */.dY)({
        path: staticProps.cartUrl
      });
    }
  }))), react.createElement(CategoriesContainer, null, react.createElement(Categories_Categories, {
    allCategories: allCategories,
    highlighted: highlighted,
    storeName: store.name
  })));
}
 false ? 0 : void 0;
HeaderDesktopPMD.defaultProps = {
  data: {},
  "static": {
    cartUrl: '',
    loggedMenu: {},
    logInMenu: {},
    loyalty: {},
    store: {
      image: null,
      name: ''
    }
  },
  structure: {}
};
HeaderDesktopPMD.dataSource = {
  categories: {
    query: 'AllCategoriesQuery'
  },
  channel: {
    query: 'ChannelQuery'
  }
};
HeaderDesktopPMD.ssr = true;
HeaderDesktopPMD.displayName = 'HeaderDesktopPMD';
/* harmony default export */ var HeaderDesktopPMD_HeaderDesktopPMD = ((0,withLayoutProps/* default */.Z)(HeaderDesktopPMD));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktopPMD/index.js


/***/ }),

/***/ 78835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HeaderPME_HeaderPME; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/SearchInput/index.js + 10 modules
var SearchInput = __webpack_require__(37222);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/IconButton/index.js + 2 modules
var IconButton = __webpack_require__(15309);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 39 modules
var structure_build_esm = __webpack_require__(48728);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderPME/HeaderPME.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;





var AlignIcon = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  gap: 4px;\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n\n  > * {\n    padding: 8px;\n    cursor: pointer;\n  }\n"])));
var ContainerButton = styled_components_browser_esm["default"].div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: -8px;\n\n  > * {\n    padding: 8px;\n    cursor: pointer;\n  }\n"])));
var Content = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  background: ", ";\n  height: ", ";\n  color: ", ";\n  padding: 0 16px;\n  position: relative;\n"])), function (props) {
  return (0,utils/* themeGet */.R)('palette.background.primary')(props);
}, function (props) {
  return (0,utils/* themeGet */.R)('sizes.header')(props);
}, function (props) {
  return (0,utils/* themeGet */.R)('palette.background.white')(props);
});
var HeaderTitle = styled_components_browser_esm["default"].h1(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", ";\n  margin-left: 18px;\n"])), function (props) {
  return (0,utils/* themeGet */.R)('fontSizes.4')(props);
}, function (props) {
  return (0,utils/* themeGet */.R)('fontWeights.regular')(props);
}, function (props) {
  return (0,utils/* themeGet */.R)('lineHeights.fontSize')(props);
});
var LogoPrefix = styled_components_browser_esm["default"].strong(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  margin-right: 2px;\n"])), function (props) {
  return (0,utils/* getPaletteColor */.ow)('primary.dark')(props);
});
var LogoText = (0,styled_components_browser_esm["default"])(Heading/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'text',
    fontSize: 1,
    fontWeight: 'bold',
    lineHeight: "".concat((0,utils/* themeGet */.R)('lineHeights.tall')(props), "px"),
    marginLeft: '20px'
  }, props);
})(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var HeaderPME_styles_SearchInput = (0,styled_components_browser_esm["default"])(SearchInput/* default */.Z)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: 5px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderPME/MenuPME.js





function MenuPME(_ref) {
  var backButton = _ref.backButton,
    goBack = _ref.goBack,
    openMenu = _ref.openMenu;
  if (backButton) {
    return react.createElement(ContainerButton, null, react.createElement(IconButton/* default */.Z, {
      name: "ArrowBack",
      onClick: goBack
    }, react.createElement(esm/* ArrowBack */.xhZ, {
      role: "button",
      "aria-label": "Voltar a P\xE1gina",
      "data-testid": "button-back",
      color: "#fff"
    })));
  }
  return react.createElement(ContainerButton, null, react.createElement(IconButton/* default */.Z, {
    name: "Burger",
    onClick: openMenu
  }, react.createElement(esm/* Burger */.OWX, {
    role: "button",
    "aria-label": "abrir o menu",
    "data-testid": "button-burger",
    color: "#fff"
  })));
}
 false ? 0 : void 0;
MenuPME.defaultProps = {
  backButton: false,
  goBack: function goBack() {},
  openMenu: function openMenu() {}
};
MenuPME.displayName = 'MenuPME';
/* harmony default export */ var HeaderPME_MenuPME = (MenuPME);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderPME/HeaderPME.js














var FIRST_INDEX = 0;
var getClearName = function getClearName() {
  var storeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var prefix = arguments.length > 1 ? arguments[1] : undefined;
  return storeName.indexOf(prefix) === FIRST_INDEX ? storeName.replace(prefix, '') : storeName;
};
var formatNewTermUrl = function formatNewTermUrl(newTerm, searchUrl) {
  var termStr = newTerm ? "".concat((0,structure_build_esm/* termToUrl */.Bl)((0,utils_build_esm/* slug */.oF)(newTerm)), "/") : '';
  return "".concat(searchUrl, "/").concat(termStr).replace('//', '/');
};
var handleShare = function handleShare(message) {
  var text = message.replace(/\\n/g, '\n');
  if (navigator.share) {
    navigator.share({
      text: text
    });
  } else {
    window.open("https://web.whatsapp.com/send?text=".concat(encodeURIComponent(text)), '_blank');
  }
};
var renderShareButton = function renderShareButton(message) {
  return message && react.createElement(IconButton/* default */.Z, {
    name: "Share",
    onClick: function onClick() {
      return handleShare(message);
    }
  }, react.createElement(esm/* Share */.mBz, {
    role: "button",
    "aria-label": "Compartilhar",
    "data-testid": "button-share",
    color: "#fff"
  }));
};
function HeaderPME(_ref) {
  var _structure$route4;
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var backButton = staticProps.backButton,
    headerData = staticProps.headerData,
    prefixLogo = staticProps.prefixLogo,
    searchUrl = staticProps.searchUrl,
    title = staticProps.title,
    shareMessage = staticProps.shareMessage;
  var _structure$route = structure.route,
    route = _structure$route === void 0 ? {} : _structure$route,
    _structure$cookies = structure.cookies,
    cookies = _structure$cookies === void 0 ? {} : _structure$cookies;
  var _route$term = route.term,
    initialQuery = _route$term === void 0 ? '' : _route$term,
    storeName = route.storeId;
  var partnerId = cookies.partnerId;
  var _useSuggestions = (0,build_esm.useSuggestions)({
      partnerId: partnerId
    }),
    suggestions = _useSuggestions.suggestions,
    getSuggestions = _useSuggestions.getSuggestions,
    cleanSuggestions = _useSuggestions.cleanSuggestions;
  var _useState = (0,react.useState)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    chosenSuggestion = _useState2[0],
    setChosenSuggestion = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    openSearch = _useState4[0],
    setOpenSearch = _useState4[1];
  var _useState5 = (0,react.useState)(initialQuery),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    term = _useState6[0],
    setTerm = _useState6[1];
  (0,react.useEffect)(function () {
    if (openSearch) {
      var input = document.getElementById('input-search');
      if (input) {
        input.click();
      }
    }
  }, [openSearch]);
  var publishSuggestionFromRoute = function publishSuggestionFromRoute(suggestion) {
    var position = suggestions.findIndex(function (item) {
      return item.term === suggestion;
    }) + 1;
    publish('suggestion:click', {
      position: position,
      term: suggestion
    });
  };
  (0,react.useEffect)(function () {
    var _structure$route2;
    if (chosenSuggestion && chosenSuggestion.includes(structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term)) {
      var _structure$route3;
      publishSuggestionFromRoute(structure == null ? void 0 : (_structure$route3 = structure.route) == null ? void 0 : _structure$route3.term);
    }
  }, [structure == null ? void 0 : (_structure$route4 = structure.route) == null ? void 0 : _structure$route4.term, chosenSuggestion]);
  var handleBack = function handleBack() {
    router_default().back();
  };
  var onSearch = function onSearch(e, newTerm) {
    e.preventDefault();
    var newTermTrim = newTerm.trim();
    if (e.type === 'submit' && newTermTrim) {
      publish('search:submit', {
        term: newTermTrim
      });
    }
    var newTermUrl = formatNewTermUrl(newTermTrim, searchUrl);
    setOpenSearch(false);
    (0,utils_build_esm/* routePush */.dY)({
      path: newTermUrl,
      spa: true
    });
  };
  var handleOpenMenu = function handleOpenMenu() {
    return window.parent.postMessage('open menu pme', '*');
  };
  var handleSuggest = function handleSuggest(suggestionsTerm) {
    getSuggestions({
      term: suggestionsTerm
    });
  };
  var handleSuggestionClick = function handleSuggestionClick(suggestion) {
    setChosenSuggestion(suggestion);
  };
  var onOpenInput = function onOpenInput() {
    if (term.trim() && !suggestions.length) {
      handleSuggest(term);
    }
  };
  var onCloseInput = function onCloseInput() {
    publish('search:close', {
      term: term
    });
    setOpenSearch(false);
  };
  var onClearInput = function onClearInput() {
    publish('search:clear', {
      term: term
    });
    cleanSuggestions();
  };
  var handleTermTypeChange = function handleTermTypeChange(newTerm) {
    setTerm(newTerm);
    handleSuggest(newTerm);
  };
  if (openSearch) {
    var _headerData$search;
    return react.createElement(SearchInput/* default */.Z, {
      onSearch: onSearch,
      onInputClear: onClearInput,
      onSuggestItemClick: handleSuggestionClick,
      onTypeChange: handleTermTypeChange,
      onInputClose: onCloseInput,
      onInputOpen: onOpenInput,
      placeholder: headerData == null ? void 0 : (_headerData$search = headerData.search) == null ? void 0 : _headerData$search.placeholder,
      initialValue: term,
      list: suggestions,
      autoFocus: true
    });
  }
  return react.createElement("header", null, react.createElement(Content, null, react.createElement(HeaderPME_MenuPME, {
    backButton: backButton,
    goBack: handleBack,
    openMenu: handleOpenMenu
  }), react.createElement("div", null, react.createElement(HeaderTitle, null, title), react.createElement(LogoText, null, react.createElement(LogoPrefix, null, prefixLogo), getClearName(storeName, prefixLogo))), react.createElement(AlignIcon, null, react.createElement(IconButton/* default */.Z, {
    name: "Search",
    onClick: function onClick() {
      return setOpenSearch(true);
    }
  }, react.createElement(esm/* Search */.olm, {
    role: "button",
    "aria-label": "abrir a busca",
    "data-testid": "button-search",
    color: "#fff"
  })), renderShareButton(shareMessage))));
}
 false ? 0 : void 0;
HeaderPME.defaultProps = {
  "static": {
    backButton: false,
    headerData: {},
    prefixLogo: 'parceiro',
    searchUrl: '/busca/',
    title: 'Vender'
  },
  structure: {}
};
HeaderPME.dataSource = {
  categories: {
    query: 'AllCategoriesQuery'
  },
  channel: {
    query: 'ChannelQuery'
  }
};
HeaderPME.ssr = true;
HeaderPME.displayName = 'HeaderPME';
/* harmony default export */ var HeaderPME_HeaderPME = ((0,withLayoutProps/* default */.Z)(HeaderPME));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeaderPME/index.js


/***/ }),

/***/ 89940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Heading_Heading; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var atoms_Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Heading/Heading.js






var Heading = function Heading(_ref) {
  var staticProps = _ref["static"];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var title = staticProps.title,
    msg = staticProps.publish;
  var handleClick = function handleClick() {
    if (msg) publish(msg);
  };
  return !title ? null : react.createElement(atoms_Heading/* default */.Z, (0,esm_extends/* default */.Z)({
    as: "h1"
  }, staticProps, {
    onClick: handleClick
  }), title);
};
 false ? 0 : void 0;
Heading.defaultProps = {
  "static": {}
};
Heading.ssr = true;
/* harmony default export */ var Heading_Heading = ((0,withLayoutProps/* default */.Z)(Heading));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Heading/index.js


/***/ }),

/***/ 63001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HeadingProduct_HeadingProduct; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeadingProduct/styles.js

var _templateObject;


var Separator = styled_components_browser_esm["default"].span(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  &:before {\n    content: '|';\n    margin: 0 ", "px;\n    color: ", ";\n  }\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('space.1')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.getTextColor)('light')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeadingProduct/HeadingProduct.js


var _excluded = ["brandSpa", "descriptionClick", "productSku", "productBrand", "subHeadingStatic"];










var onLinkClick = function onLinkClick(link, brandSpa) {
  return function (e) {
    e.preventDefault();
    (0,build_esm/* routePush */.dY)({
      path: link,
      spa: brandSpa
    });
  };
};
function SubHeading(_ref) {
  var brandSpa = _ref.brandSpa,
    descriptionClick = _ref.descriptionClick,
    productSku = _ref.productSku,
    productBrand = _ref.productBrand,
    subHeadingStatic = _ref.subHeadingStatic,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var skuPrefix = subHeadingStatic.skuPrefix,
    descriptionLink = subHeadingStatic.descriptionLink;
  return react.createElement(Box/* default */.Z, (0,esm_extends/* default */.Z)({
    as: "span",
    fontSize: 1
  }, props), react.createElement(Text/* default */.Z, (0,esm_extends/* default */.Z)({
    as: "span",
    color: "text.light"
  }, props), skuPrefix, " ", productSku), react.createElement(Separator, {
    color: "text.light"
  }), react.createElement(Link/* default */.Z, (0,esm_extends/* default */.Z)({
    onClick: descriptionClick,
    color: "text.light",
    underline: true
  }, props), descriptionLink), react.createElement(Separator, {
    color: "text.light"
  }), react.createElement(Link/* default */.Z, (0,esm_extends/* default */.Z)({
    onClick: onLinkClick(productBrand == null ? void 0 : productBrand.url, brandSpa),
    href: productBrand == null ? void 0 : productBrand.url,
    color: "text.light",
    underline: true
  }, props, {
    "data-testid": "heading-product-brand"
  }), productBrand == null ? void 0 : productBrand.label));
}
 false ? 0 : void 0;
var HeadingProduct = function HeadingProduct(_ref2) {
  var staticProps = _ref2["static"],
    data = _ref2.data,
    structure = _ref2.structure;
  var elemRef = (0,react.useRef)(null);
  var _structure$basePath = structure.basePath,
    basePath = _structure$basePath === void 0 ? '' : _structure$basePath;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _ref3 = (data == null ? void 0 : data.product) || {},
    title = _ref3.title,
    productSku = _ref3.variationId,
    productBrand = _ref3.brand;
  var msg = staticProps.publish,
    _staticProps$brandSpa = staticProps.brandSpa,
    brandSpa = _staticProps$brandSpa === void 0 ? true : _staticProps$brandSpa,
    subHeading = staticProps.subHeading;
  var fullTitle = (0,build_esm/* getFullTitle */.HV)((data == null ? void 0 : data.product) || {});
  var handleClick = function handleClick() {
    if (msg) publish(msg);
  };
  var handleTitleClickEvent = function handleTitleClickEvent() {
    return (0,build_esm/* scrollToRef */.BC)(elemRef);
  };
  (0,react.useEffect)(function () {
    subscribe('product:title:click', handleTitleClickEvent);
    return function () {
      unsubscribe('product:title:click', handleTitleClickEvent);
    };
  });
  var brandSlug = (0,build_esm/* slug */.oF)(productBrand == null ? void 0 : productBrand.label);
  var hasInvalidProps = !title || !productSku || !productBrand;
  return !hasInvalidProps && react.createElement(react.Fragment, null, react.createElement(Heading/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "heading-product-title",
    as: "h1"
  }, staticProps, {
    ref: elemRef
  }), fullTitle), react.createElement(SubHeading, {
    descriptionClick: handleClick,
    productSku: productSku,
    productBrand: (0,esm_extends/* default */.Z)({}, productBrand, {
      url: "".concat(basePath, "/marcas/").concat(brandSlug, "/")
    }),
    brandSpa: brandSpa,
    subHeadingStatic: subHeading
  }));
};
 false ? 0 : void 0;
HeadingProduct.defaultProps = {
  data: {},
  "static": {}
};
HeadingProduct.ssr = true;
HeadingProduct.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
/* harmony default export */ var HeadingProduct_HeadingProduct = ((0,withLayoutProps/* default */.Z)(HeadingProduct));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeadingProduct/index.js


/***/ }),

/***/ 42724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HeadingSeller_HeadingSeller; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeadingSeller/HeadingSeller.js






var HeadingSeller = function HeadingSeller(_ref) {
  var _currentSeller$seller;
  var data = _ref.data,
    staticProps = _ref["static"];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var msg = staticProps.publish,
    sellerId = staticProps.sellerId;
  var _ref2 = (data == null ? void 0 : data.search) || {},
    products = _ref2.products;
  var handleClick = function handleClick() {
    if (msg) publish(msg);
  };
  var currentSeller = products == null ? void 0 : products.find(function (item) {
    var _item$seller;
    return (item == null ? void 0 : (_item$seller = item.seller) == null ? void 0 : _item$seller.id) === sellerId;
  });
  var title = currentSeller == null ? void 0 : (_currentSeller$seller = currentSeller.seller) == null ? void 0 : _currentSeller$seller.description;
  return !title ? null : react.createElement(Heading/* default */.Z, (0,esm_extends/* default */.Z)({
    as: "h1"
  }, staticProps, {
    onClick: handleClick
  }), title);
};
 false ? 0 : void 0;
HeadingSeller.defaultProps = {
  data: {},
  "static": {}
};
HeadingSeller.ssr = true;
/* harmony default export */ var HeadingSeller_HeadingSeller = ((0,withLayoutProps/* default */.Z)(HeadingSeller));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HeadingSeller/index.js


/***/ }),

/***/ 76312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HotLinks_HotLinks; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HotLinks/index.js + 2 modules
var molecules_HotLinks = __webpack_require__(2490);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HotLinks/HotLinks.js


var _excluded = ["items", "TitleText", "titleProps", "DescriptionText", "spa", "ga"];









var HotLinks = function HotLinks(_ref) {
  var staticProps = _ref["static"];
  var _staticProps$items = staticProps.items,
    items = _staticProps$items === void 0 ? [] : _staticProps$items,
    TitleText = staticProps.TitleText,
    _staticProps$titlePro = staticProps.titleProps,
    titleProps = _staticProps$titlePro === void 0 ? {} : _staticProps$titlePro,
    DescriptionText = staticProps.DescriptionText,
    _staticProps$spa = staticProps.spa,
    spa = _staticProps$spa === void 0 ? false : _staticProps$spa,
    _staticProps$ga = staticProps.ga,
    ga = _staticProps$ga === void 0 ? {} : _staticProps$ga,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleItemClick = function handleItemClick(_e, _ref2) {
    var text = _ref2.text,
      link = _ref2.link;
    publish('hotlink:click', {
      ga: ga,
      text: text
    });
    if (spa) {
      _e.preventDefault();
      (0,build_esm/* routePush */.dY)({
        path: link,
        spa: true
      });
    }
  };
  var parseItems = items == null ? void 0 : items.map(function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref3.id,
      _ref3$link = _ref3.link,
      _ref3$link2 = _ref3$link === void 0 ? {} : _ref3$link,
      text = _ref3$link2.text,
      href = _ref3$link2.href,
      src = _ref3.image.src;
    return {
      id: id,
      image: src,
      link: href,
      text: text
    };
  });
  return react.createElement(Box/* default */.Z, (0,esm_extends/* default */.Z)({
    as: "section",
    p: "15px 8px",
    bg: "white"
  }, props), TitleText && react.createElement(Heading/* default */.Z, (0,esm_extends/* default */.Z)({
    as: "h2",
    m: "10px 0",
    fontSize: [4, 1, 1]
  }, titleProps), TitleText), DescriptionText && react.createElement(Text/* default */.Z, {
    mb: "20px"
  }, DescriptionText), react.createElement(molecules_HotLinks/* default */.Z, {
    items: parseItems,
    onItemClick: handleItemClick
  }));
};
HotLinks.defaultProps = {
  "static": {
    items: []
  }
};
 false ? 0 : void 0;
HotLinks.ssr = true;
/* harmony default export */ var HotLinks_HotLinks = ((0,withLayoutProps/* default */.Z)(HotLinks));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/HotLinks/index.js


/***/ }),

/***/ 29531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image_Image; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Image/Image.js


var _excluded = ["href", "preload", "spa"];







var Image = function Image(_ref) {
  var _ref$static = _ref["static"],
    href = _ref$static.href,
    preload = _ref$static.preload,
    spa = _ref$static.spa,
    staticProps = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded);
  var safeStaticProps = (0,esm_extends/* default */.Z)({}, staticProps, staticProps.width && staticProps.width.toString().trim() !== '' && {
    width: staticProps.width
  }, staticProps.height && staticProps.height.toString().trim() !== '' && {
    height: staticProps.height
  });
  if (href) {
    var handleOnClick = function handleOnClick(e) {
      e.preventDefault();
      (0,esm/* routePush */.dY)({
        path: href,
        spa: spa
      });
    };
    return react.createElement(react.Fragment, null, preload && react.createElement((head_default()), null, react.createElement("link", {
      "data-testid": "preload",
      rel: "preload",
      as: "image",
      href: safeStaticProps.src
    })), react.createElement(Link/* default */.Z, {
      "data-testid": "image-link",
      href: href,
      onClick: handleOnClick
    }, react.createElement(ResponsiveImage/* default */.Z, safeStaticProps)));
  }
  return react.createElement(ResponsiveImage/* default */.Z, safeStaticProps);
};
 false ? 0 : void 0;
Image.defaultProps = {
  "static": {
    height: 'auto',
    href: '',
    lazy: true,
    spa: false,
    src: '',
    width: '100%'
  }
};
Image.ssr = true;
/* harmony default export */ var Image_Image = ((0,withLayoutProps/* default */.Z)(Image));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Image/index.js


/***/ }),

/***/ 69979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ImportTaxes_ImportTaxes; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/index.js + 4 modules
var organisms_ImportTaxes = __webpack_require__(66608);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ImportTaxes/ImportTaxes.js








var ImportTaxes = function ImportTaxes(_ref) {
  var data = _ref.data,
    showDialog = _ref["static"].showDialog;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useImportTax = (0,build_esm.useImportTax)(),
    getImportTax = _useImportTax.getImportTax,
    tax = _useImportTax.tax;
  var _usePublisher2 = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher2.publish;
  (0,react.useEffect)(function () {
    var handleEvent = function handleEvent(value) {
      return (0,utils_build_esm/* getTaxes */.fb)(value, getImportTax);
    };
    subscribe('shippmment:finished', handleEvent);
    return function () {
      unsubscribe('shippmment:finished', handleEvent);
    };
  }, [subscribe, unsubscribe, getImportTax]);
  var onDetailsClose = function onDetailsClose() {
    publish('product:importTaxesClose:click');
  };
  var props = (0,esm_extends/* default */.Z)({
    isIncludeTaxes: !!(tax == null ? void 0 : tax.importTax),
    onDetailsClose: onDetailsClose,
    showDialog: showDialog,
    totalValueICMS: tax == null ? void 0 : tax.icms,
    totalValueImportTax: tax == null ? void 0 : tax.importTax
  }, data);
  return react.createElement(organisms_ImportTaxes/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "import-taxes-component"
  }, props));
};
 false ? 0 : void 0;
ImportTaxes.defaultProps = {
  data: {},
  "static": {
    showDialog: false
  }
};
ImportTaxes.ssr = true;
/* harmony default export */ var ImportTaxes_ImportTaxes = ((0,withLayoutProps/* default */.Z)(ImportTaxes));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ImportTaxes/index.js


/***/ }),

/***/ 19750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LetMeKnow_LetMeKnow; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/index.js + 2 modules
var AlertText = __webpack_require__(52337);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LetMeKnow/index.js + 2 modules
var organisms_LetMeKnow = __webpack_require__(75057);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LetMeKnow/LetMeKnow.js




var _excluded = ["origin", "success"];
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }









var LetMeKnow = function LetMeKnow(_ref) {
  var data = _ref.data,
    _ref$static = _ref["static"],
    origin = _ref$static.origin,
    success = _ref$static.success,
    staticProps = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded),
    structure = _ref.structure;
  var _useLetMeKnow = (0,graphql_build_esm.useLetMeKnow)(),
    subscribeToLetMeKnow = _useLetMeKnow.subscribeToLetMeKnow,
    error = _useLetMeKnow.error,
    dataLetMeKnow = _useLetMeKnow.data;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    _ref2$category = _ref2.category,
    category = _ref2$category === void 0 ? {} : _ref2$category,
    _ref2$subcategory = _ref2.subcategory,
    subcategory = _ref2$subcategory === void 0 ? {} : _ref2$subcategory;
  var _buildSubcategoryPath = (0,build_esm/* buildSubcategoryPath */.ey)((0,esm_extends/* default */.Z)({}, subcategory, {
      label: subcategory.name
    }), (0,esm_extends/* default */.Z)({}, category, {
      label: category.name
    })),
    path = _buildSubcategoryPath.path;
  var handleSubmit = function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(_ref3) {
      var _data$product;
      var email, fullName, newsletter;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            email = _ref3.email, fullName = _ref3.fullName, newsletter = _ref3.newsletter;
            _context.next = 3;
            return subscribeToLetMeKnow({
              email: email,
              name: fullName,
              newsletter: newsletter,
              origin: origin,
              sku: data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.id
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  (0,react.useEffect)(function () {
    publish('product:details', {
      deliveries: null,
      product: data == null ? void 0 : data.product,
      shippingError: null,
      structure: structure
    });
  }, []);
  return react.createElement(react.Fragment, null, react.createElement(organisms_LetMeKnow/* default */.Z, {
    staticProps: staticProps,
    noticeMeLink: path,
    onSubmit: handleSubmit
  }), (dataLetMeKnow || error) && react.createElement(Flex/* default */.Z, {
    pt: 3,
    flexDirection: ['column', 'row'],
    gap: [0, 30]
  }, dataLetMeKnow && react.createElement(AlertText/* default */.Z, {
    message: success,
    intent: "success"
  }), error && react.createElement(AlertText/* default */.Z, {
    message: error,
    intent: "danger"
  })));
};
 false ? 0 : void 0;
LetMeKnow.defaultProps = {
  data: {},
  "static": {},
  structure: {
    cookies: {}
  }
};
LetMeKnow.ssr = true;
LetMeKnow.displayName = 'LetMeKnow';
/* harmony default export */ var LetMeKnow_LetMeKnow = ((0,withLayoutProps/* default */.Z)(LetMeKnow));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LetMeKnow/index.js


/***/ }),

/***/ 94978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Link_Link; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var atoms_Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Link/Link.js


var _excluded = ["path", "pathSufix", "toggleAutoShipping", "label", "publish", "spa", "refresh", "onlyHref"];






var Link = function Link(_ref) {
  var StaticProps = _ref["static"];
  var path = StaticProps.path,
    _StaticProps$pathSufi = StaticProps.pathSufix,
    pathSufix = _StaticProps$pathSufi === void 0 ? '' : _StaticProps$pathSufi,
    toggleAutoShipping = StaticProps.toggleAutoShipping,
    label = StaticProps.label,
    event = StaticProps.publish,
    spa = StaticProps.spa,
    refresh = StaticProps.refresh,
    onlyHref = StaticProps.onlyHref,
    props = (0,objectWithoutProperties/* default */.Z)(StaticProps, _excluded);
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var completePath = "".concat(path).concat(pathSufix);
  var handleOnClick = function handleOnClick(e) {
    if (!onlyHref) e.preventDefault();
    if (event) publish(event);
    if (!onlyHref) (0,build_esm/* routePush */.dY)({
      path: completePath,
      refresh: refresh,
      spa: spa
    });
  };
  return react.createElement(atoms_Link/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "link",
    href: completePath,
    onClick: handleOnClick,
    display: "inline-block"
  }, props), label);
};
 false ? 0 : void 0;
Link.defaultProps = {
  "static": {},
  structure: {
    config: {}
  }
};
Link.ssr = true;
Link.displayName = 'Link';
/* harmony default export */ var Link_Link = ((0,withLayoutProps/* default */.Z)(Link));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Link/index.js


/***/ }),

/***/ 12217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LinkList_LinkList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 39 modules
var build_esm = __webpack_require__(48728);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LinkList/LinkList.styles.js

var _templateObject;


var LinkList_styles_List = (0,styled_components_browser_esm["default"])(List/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  > li > a:hover {\n    text-decoration: underline;\n  }\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LinkList/LinkList.js


var _excluded = ["items", "titleText"],
  _excluded2 = ["value", "href"];







var LinkList = function LinkList(_ref) {
  var _items$filter;
  var id = _ref.id,
    _ref$static = _ref["static"],
    _ref$static$items = _ref$static.items,
    items = _ref$static$items === void 0 ? [] : _ref$static$items,
    titleText = _ref$static.titleText,
    props = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded),
    basePath = _ref.structure.basePath;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var parseItems = Array.isArray(items) && (items == null ? void 0 : (_items$filter = items.filter(Boolean)) == null ? void 0 : _items$filter.map(function (_ref2) {
    var term = _ref2.term,
      value = _ref2.value,
      alt = _ref2.alt,
      href = _ref2.href;
    return {
      alt: term || alt,
      href: term ? "".concat(basePath, "/busca/").concat((0,build_esm/* termToUrl */.Bl)(term), "/") : "".concat(basePath).concat(href),
      value: term || value
    };
  }));
  var handleClick = function handleClick(e, href, value) {
    e.preventDefault();
    publish('listlink:click', {
      label: value
    });
    (0,esm/* routePush */.dY)({
      path: href,
      spa: true
    });
  };
  return (parseItems == null ? void 0 : parseItems.length) > 0 ? react.createElement(LinkList_styles_List, (0,esm_extends/* default */.Z)({
    "data-testid": "link-list"
  }, props), titleText && react.createElement(LinkList_styles_List.Header, {
    "data-testid": "link-list-header"
  }, titleText), parseItems == null ? void 0 : parseItems.map(function (_ref3, index) {
    var value = _ref3.value,
      href = _ref3.href,
      itemProps = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded2);
    return react.createElement(LinkList_styles_List.Item, (0,esm_extends/* default */.Z)({
      as: "a",
      scale: "small",
      key: "".concat(id, "-").concat(index + 1),
      href: href
    }, itemProps, {
      onClick: function onClick(e) {
        return handleClick(e, href, value);
      }
    }), value);
  })) : null;
};
 false ? 0 : void 0;
LinkList.defaultProps = {
  id: 'list',
  "static": {},
  structure: {}
};
LinkList.ssr = true;
/* harmony default export */ var LinkList_LinkList = ((0,withLayoutProps/* default */.Z)(LinkList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LinkList/index.js


/***/ }),

/***/ 91001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ List_List; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var molecules_List = __webpack_require__(78012);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/List/List.js


var _excluded = ["items", "global", "event"],
  _excluded2 = ["value"];





var List = function List(_ref) {
  var id = _ref.id,
    staticProps = _ref["static"];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _staticProps$items = staticProps.items,
    items = _staticProps$items === void 0 ? [] : _staticProps$items,
    _staticProps$global = staticProps.global,
    global = _staticProps$global === void 0 ? {} : _staticProps$global,
    event = staticProps.event,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var handleClick = function handleClick(item) {
    if (event) {
      return publish(event, {
        category: id,
        item: item.value
      });
    }
    return publish('list-item:click', item);
  };
  return react.createElement(molecules_List/* default */.Z, (0,esm_extends/* default */.Z)({
    variant: "light"
  }, props), items.map(function (_ref2, index) {
    var value = _ref2.value,
      itemProps = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);
    return react.createElement(molecules_List/* default.Item */.Z.Item, (0,esm_extends/* default */.Z)({
      as: "a",
      key: "".concat(id, "-").concat(index + 1)
    }, global, itemProps, {
      onClick: function onClick() {
        return handleClick((0,esm_extends/* default */.Z)({
          value: value
        }, itemProps));
      }
    }), value);
  }));
};
 false ? 0 : void 0;
List.defaultProps = {
  id: 'list',
  "static": {}
};
List.ssr = true;
/* harmony default export */ var List_List = ((0,withLayoutProps/* default */.Z)(List));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/List/index.js


/***/ }),

/***/ 79331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Loader_Loader; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/PageLoading/index.js + 2 modules
var PageLoading = __webpack_require__(26527);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Loader/Loader.js





var Loader = function Loader() {
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var handleRouteChangeStart = function handleRouteChangeStart() {
    setLoading(true);
  };
  var handleRouteChangeComplete = function handleRouteChangeComplete() {
    setLoading(false);
  };
  var handleRouteChangeError = function handleRouteChangeError() {
    setLoading(false);
  };
  (0,react.useEffect)(function () {
    subscribe('page:loading', setLoading);
    router_default().events.on('routeChangeStart', handleRouteChangeStart);
    router_default().events.on('routeChangeComplete', handleRouteChangeComplete);
    router_default().events.on('routeChangeError', handleRouteChangeError);
    return function () {
      unsubscribe('page:loading', setLoading);
      router_default().events.off('routeChangeStart', handleRouteChangeStart);
      router_default().events.off('routeChangeComplete', handleRouteChangeComplete);
      router_default().events.off('routeChangeError', handleRouteChangeError);
    };
  }, []);
  if (loading) {
    return react.createElement("div", {
      "data-testid": "loading"
    }, react.createElement(PageLoading/* default */.Z, null));
  }
  return react.createElement(react.Fragment, null);
};
Loader.ssr = false;
/* harmony default export */ var Loader_Loader = (Loader);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Loader/index.js


/***/ }),

/***/ 6583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LoginMenuPMD_LoginMenuPMD; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/index.js + 7 modules
var Dropdown = __webpack_require__(74822);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoginMenuPMD/LoggedMenu/LoggedMenu.styles.js

var _templateObject;


var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 20px;\n  position: relative;\n  & button {\n    width: 165px;\n    &:focus {\n      outline: 5px auto Highlight;\n      outline: 5px auto -webkit-focus-ring-color;\n    }\n    & > label {\n      font-weight: ", ";\n    }\n  }\n"])), (0,build_esm.themeGet)('fontWeight.regular'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoginMenuPMD/LoggedMenu/LoggedMenu.js







function LoggedMenu(_ref) {
  var data = _ref.data,
    isPromoter = _ref.isPromoter,
    userName = _ref.userName;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showMenu = _useState2[0],
    setShowMenu = _useState2[1];
  var _useState3 = (0,react.useState)([]),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    menuList = _useState4[0],
    setMenuList = _useState4[1];
  (0,react.useEffect)(function () {
    if (data.menuItems) {
      var items = data.menuItems.filter(function (item) {
        return (isPromoter && data.promoterMenu || data.clientMenu).includes(item.id);
      });
      setMenuList(items);
    }
  }, [isPromoter]);
  (0,react.useEffect)(function () {
    setShowMenu(true);
  }, []);
  var getIcon = function getIcon(icon) {
    return react.createElement(esm/* Icon */.JO$, {
      name: icon,
      color: "#404040"
    });
  };
  return react.createElement(Container, null, showMenu && react.createElement(Dropdown/* default */.Z, {
    mouseenter: true,
    pointing: true
  }, react.createElement(Dropdown/* default.Title */.Z.Title, {
    color: "text.white",
    fill: "background.lighter"
  }, react.createElement("span", null, "Ol\xE1,\xA0", react.createElement("b", null, userName && userName.split(' ')[0]))), react.createElement(Dropdown/* default.Menu */.Z.Menu, {
    pointing: true,
    fontSize: 0,
    p: 2
  }, menuList.map(function (_ref2) {
    var icon = _ref2.icon,
      id = _ref2.id,
      label = _ref2.label,
      url = _ref2.url;
    return react.createElement(Dropdown/* default.Item */.Z.Item, {
      key: id,
      startIcon: getIcon(icon),
      p: 1,
      my: 2
    }, react.createElement(Link/* default */.Z, {
      href: url,
      fontSize: 0
    }, label));
  }), react.createElement(Dropdown/* default.Divider */.Z.Divider, null), react.createElement(Dropdown/* default.Item */.Z.Item, {
    p: 1,
    my: 2,
    disableHover: true
  }, userName && "N\xE3o \xE9 ".concat(userName.split(' ')[0], "? "), react.createElement(Link/* default */.Z, {
    underline: true,
    px: 0,
    fontSize: 0,
    href: data.logoutUrl,
    "data-testid": "link-logout"
  }, "Sair")))));
}
 false ? 0 : void 0;
LoggedMenu.defaultProps = {
  isPromoter: false,
  userName: ''
};
/* harmony default export */ var LoggedMenu_LoggedMenu = (LoggedMenu);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoginMenuPMD/LoggedMenu/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/index.js
var stereo_ui_build_esm = __webpack_require__(87302);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoginMenuPMD/LogInMenu/LogInMenu.styles.js


var LogInMenu_styles_templateObject, _templateObject2, _templateObject3, _templateObject4;



var ButtonContainer = styled_components_browser_esm["default"].div(LogInMenu_styles_templateObject || (LogInMenu_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  & button {\n    width: 200px;\n    margin-bottom: 8px;\n    & > label {\n      font-weight: ", ";\n    }\n  }\n\n  & hr {\n    border: 0;\n    border-top: ", ";\n    margin: 10px 0 5px 0;\n  }\n"])), (0,build_esm.themeGet)('fontWeight.regular'), (0,build_esm.themeGet)('borders.0'));
var Content = styled_components_browser_esm["default"].div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-right: 30px;\n  font-size: ", "px;\n  color: ", ";\n  line-height: 20px;\n\n  & > button {\n    padding: 0;\n    display: flex;\n    text-wrap: nowrap;\n  }\n"])), (0,build_esm.getFontSize)(1), (0,build_esm.getTextColor)('lightest'));
var Menu = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: ", ";\n  position: absolute;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  margin-top: 2px;\n  padding: 10px;\n  padding-bottom: 0;\n  z-index: 1;\n\n  & a {\n    cursor: pointer;\n    text-align: center;\n    font-size: ", "px;\n    color: ", ";\n    background: ", ";\n    text-decoration: none;\n    width: 100%;\n    display: inline-block;\n    padding-bottom: 10px;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (_ref) {
  var display = _ref.display;
  return display ? 'block' : 'none';
}, (0,build_esm.getBackgroundColor)('lighter'), (0,build_esm.themeGet)('borders.0'), (0,build_esm.themeGet)('radii.default'), (0,build_esm.getFontSize)(1), (0,build_esm.getTextColor)('light'), (0,build_esm.getBackgroundColor)('lighter'), (0,build_esm.getPaletteColor)('magalu.base'));
var StyledLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: '#fff'
  }, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: left;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoginMenuPMD/LogInMenu/LogInMenu.js








function LogInMenu(_ref) {
  var data = _ref.data;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showMenu = _useState2[0],
    setShowMenu = _useState2[1];
  var menuRef = (0,react.useRef)();
  (0,stereo_ui_build_esm/* useOnClickOutside */.t$X)(menuRef, function () {
    setShowMenu(false);
  });
  return react.createElement(Content, null, react.createElement("strong", null, "Bem vindo :)"), react.createElement(StyledLink, {
    onClick: function onClick() {
      return setShowMenu(!showMenu);
    },
    "data-testid": "loginmenu-openmenu-button"
  }, "Entre ou cadastre-se", react.createElement(esm/* Icon */.JO$, {
    color: "#fff",
    name: "ChevronDown"
  })), react.createElement(Menu, {
    display: showMenu,
    ref: menuRef,
    "data-testid": "loginmenu-menu"
  }, react.createElement(ButtonContainer, null, react.createElement(Button/* default */.Z, {
    variation: "primary",
    size: "medium",
    uppercase: false,
    onClick: function onClick() {
      return (0,utils_build_esm/* routePush */.dY)({
        path: data.nationalUrl
      });
    },
    "data-testid": "loginmenu-client-button"
  }, "Entrar como cliente"), react.createElement(Button/* default */.Z, {
    variation: "outline",
    size: "medium",
    uppercase: false,
    onClick: function onClick() {
      return (0,utils_build_esm/* routePush */.dY)({
        path: data.promoterUrl
      });
    },
    "data-testid": "loginmenu-promoter-button"
  }, "Entrar como influenciador"), react.createElement("hr", null)), react.createElement("a", {
    href: data.nationalUrl
  }, "ou cadastre-se")));
}
 false ? 0 : void 0;
LogInMenu.defaultProps = {};
/* harmony default export */ var LogInMenu_LogInMenu = (LogInMenu);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoginMenuPMD/LogInMenu/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoginMenuPMD/LoginMenuPMD.js





function LoginMenuPMD(_ref) {
  var customLoginMenu = _ref.customLoginMenu,
    structure = _ref.structure;
  var cookies = structure.cookies;
  var _customLoginMenu$logg = customLoginMenu.loggedMenu,
    loggedMenu = _customLoginMenu$logg === void 0 ? {} : _customLoginMenu$logg,
    _customLoginMenu$logI = customLoginMenu.logInMenu,
    logInMenu = _customLoginMenu$logI === void 0 ? {} : _customLoginMenu$logI;
  var userData = cookies.promoterData || cookies.accountData;
  var isLogged = userData || false;
  var isPromoter = isLogged && cookies.promoterData;
  var renderLoggedMenu = function renderLoggedMenu() {
    return react.createElement(LoggedMenu_LoggedMenu, {
      data: loggedMenu,
      isPromoter: isPromoter,
      userName: userData.name
    });
  };
  var renderLogInMenu = function renderLogInMenu() {
    return react.createElement(LogInMenu_LogInMenu, {
      data: logInMenu,
      theme: structure == null ? void 0 : structure.theme
    });
  };
  return isLogged ? renderLoggedMenu() : renderLogInMenu();
}
LoginMenuPMD.propTypes = {
  customLoginMenu: (0,prop_types.shape)({
    loggedMenu: (0,prop_types.shape)({}),
    logInMenu: (0,prop_types.shape)({})
  }),
  structure: (0,prop_types.shape)({})
};
LoginMenuPMD.defaultProps = {
  customLoginMenu: {
    loggedMenu: {},
    logInMenu: {}
  },
  structure: {}
};
LoginMenuPMD.dataSource = {
  channel: {
    query: 'ChannelQuery'
  }
};
LoginMenuPMD.ssr = true;
LoginMenuPMD.displayName = 'LoginMenuPMD';
/* harmony default export */ var LoginMenuPMD_LoginMenuPMD = ((0,withLayoutProps/* default */.Z)(LoginMenuPMD));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoginMenuPMD/index.js


/***/ }),

/***/ 84760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LoyaltyCommission_LoyaltyCommission; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/index.js + 2 modules
var organisms_LoyaltyCommission = __webpack_require__(99075);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoyaltyCommission/LoyaltyCommission.js





var LoyaltyCommission = function LoyaltyCommission(_ref) {
  var _structure$config;
  var product = _ref.data.product,
    structure = _ref.structure,
    staticProps = _ref["static"];
  var domain = (staticProps == null ? void 0 : staticProps.domain) || (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.domain);
  var loyalty = product.loyalty,
    url = product.url;
  var productUrl = domain + url;
  return react.createElement(organisms_LoyaltyCommission/* default */.Z, (0,esm_extends/* default */.Z)({}, loyalty, {
    attributes: (0,esm_extends/* default */.Z)({}, loyalty.attributes),
    productUrl: productUrl
  }));
};
 false ? 0 : void 0;
LoyaltyCommission.defaultProps = {
  "static": {}
};
LoyaltyCommission.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
/* harmony default export */ var LoyaltyCommission_LoyaltyCommission = ((0,withLayoutProps/* default */.Z)(LoyaltyCommission));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LoyaltyCommission/index.js


/***/ }),

/***/ 7905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LuContent_LuContent; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/LuContent/index.js + 22 modules
var templates_LuContent = __webpack_require__(95949);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LuContent/LuContent.styles.js

var _templateObject;

var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LuContent/LuContent.js








var LuContent = function LuContent(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var variation = staticProps.variation,
    title = staticProps.title,
    showHeaderSocialMedia = staticProps.showHeaderSocialMedia,
    showLinkToMoreContent = staticProps.showLinkToMoreContent,
    linkToMoreContent = staticProps.linkToMoreContent,
    _staticProps$assets = staticProps.assets,
    _staticProps$assets2 = _staticProps$assets === void 0 ? {} : _staticProps$assets,
    images = _staticProps$assets2.images;
  var _data$blogHomeContent = data.blogHomeContent,
    blogHomeContent = _data$blogHomeContent === void 0 ? {} : _data$blogHomeContent,
    _data$blogPostsListin = data.blogPostsListing,
    blogPostsListing = _data$blogPostsListin === void 0 ? {} : _data$blogPostsListin,
    _data$blogPostsByEcom = data.blogPostsByEcomm,
    blogPostsByEcomm = _data$blogPostsByEcom === void 0 ? {} : _data$blogPostsByEcom;
  var _ref2 = blogHomeContent || {},
    _ref2$recommendations = _ref2.recommendations,
    blogRecommendations = _ref2$recommendations === void 0 ? [] : _ref2$recommendations;
  var blogLuContent = [].concat((0,toConsumableArray/* default */.Z)(blogRecommendations), [blogPostsListing, blogPostsByEcomm]).filter(function (item) {
    return item == null ? void 0 : item.posts;
  });
  var parsedBlogLuContent = (0,build_esm/* parseBlogLuContent */.pb)(blogLuContent, variation);
  var allBlogItems = blogLuContent.reduce(function (acc, _ref3) {
    var posts = _ref3.posts;
    return [].concat((0,toConsumableArray/* default */.Z)(acc), (0,toConsumableArray/* default */.Z)(posts));
  }, []).filter(Boolean);
  (0,react.useEffect)(function () {
    var promotionData = allBlogItems.map(function (_ref4, index) {
      var id = _ref4.id,
        articleTitle = _ref4.title,
        category = _ref4.category,
        subcategory = _ref4.subcategory;
      return {
        category: category,
        id: id,
        position: index + 1,
        subcategory: subcategory,
        title: articleTitle
      };
    });
    publish('lucontent:view', {
      eventLabel: 'promotion',
      promotions: promotionData
    });
  }, [data]);
  var handleClick = function handleClick(e, clicked) {
    var id = clicked.id,
      itemTitle = clicked.title,
      idx = clicked.idx,
      parentIdx = clicked.parentIdx;
    var position = parentIdx + 1 + idx + 1;
    publish('lucontent:click', {
      eventLabel: 'promotion',
      id: id,
      position: position,
      title: itemTitle
    });
  };
  var handleSocialMediaLinkClick = function handleSocialMediaLinkClick(_e, _ref5) {
    var id = _ref5.id;
    publish('lucontent:socialmedia:click', {
      id: id
    });
  };
  var luContentProps = {
    assets: staticProps.assets,
    data: parsedBlogLuContent,
    images: images,
    linkToMoreContent: linkToMoreContent,
    onItemClick: handleClick,
    onSocialMediaClick: handleSocialMediaLinkClick,
    showHeaderSocialMedia: showHeaderSocialMedia,
    showLinkToMoreContent: showLinkToMoreContent,
    title: title,
    variation: variation
  };
  if (allBlogItems.length === 0) {
    return null;
  }
  return react.createElement(Container, {
    "data-testid": "lucontent-container"
  }, react.createElement(templates_LuContent/* default */.ZP, luContentProps));
};
LuContent.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
 false ? 0 : void 0;
LuContent.ssr = true;
/* harmony default export */ var LuContent_LuContent = ((0,withLayoutProps/* default */.Z)(LuContent));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/LuContent/index.js


/***/ }),

/***/ 42153:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var useAdsSdk = function useAdsSdk(context, adsResponse) {
  var _window;
  if ((_window = window) == null ? void 0 : _window.magaluAdsEvents) {
    var _window2, _window2$magaluAdsEve;
    (_window2 = window) == null ? void 0 : (_window2$magaluAdsEve = _window2.magaluAdsEvents) == null ? void 0 : _window2$magaluAdsEve.init(context, adsResponse);
  } else {
    document.addEventListener('magalu.ads.events.ready', function () {
      window.magaluAdsEvents.init(context, adsResponse);
    });
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (useAdsSdk);

/***/ }),

/***/ 8431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MagaluAdsShowcase_MagaluAdsShowcase; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(71941);
var crypto_browserify_default = /*#__PURE__*/__webpack_require__.n(crypto_browserify);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/slugify/slugify.js
var slugify = __webpack_require__(76854);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/index.js + 10 modules
var Showcase = __webpack_require__(75335);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MagaluAdsShowcase/constants.js
var ADS_URL = 'https://ads-query.luizalabs.com';
var MAGALU_ADS_EVENT_READY = 'magalu.ads.events.ready';
var MAGALU_ADS_READY = 'magalu.ads.ready';
var SEACH_PAGE = 'BUSCA';
var SINGLE_PRODUCT_PAGE = 'PDP';
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/MagaluAdsShowcase/hooks/useAdsSdk.js
var useAdsSdk = __webpack_require__(42153);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MagaluAdsShowcase/hooks/useAdsData.js




function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }

function useAdsData(_ref) {
  var method = _ref.method,
    adsUrl = _ref.adsUrl,
    headers = _ref.headers,
    params = _ref.params,
    _ref$structure$route = _ref.structure.route,
    route = _ref$structure$route === void 0 ? {} : _ref$structure$route;
  var _useState = (0,react.useState)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    adsResponse = _useState2[0],
    setAdsResponse = _useState2[1];
  var _useState3 = (0,react.useState)({}),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    headersResponse = _useState4[0],
    setHeadersResponse = _useState4[1];
  var getHeader = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(headerName, responseHeaders) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return responseHeaders == null ? void 0 : responseHeaders.get(headerName);
          case 3:
            return _context.abrupt("return", _context.sent);
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            throw new Error("Error fetching header ".concat(headerName, ": ").concat(_context.t0));
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return function getHeader(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  (0,react.useEffect)(function () {
    var fetchAds = function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2() {
        var url, fetchOptions, response, result, matchReason, adRequestId, adResponseId, parsedAds;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              url = method === 'GET' ? "".concat(adsUrl, "?").concat(new URLSearchParams(params)) : adsUrl;
              fetchOptions = {
                headers: headers,
                method: method
              };
              if (method !== 'GET') {
                fetchOptions.body = JSON.stringify(params);
              }
              _context2.next = 6;
              return fetch(url, fetchOptions);
            case 6:
              response = _context2.sent;
              if (response == null ? void 0 : response.ok) {
                _context2.next = 9;
                break;
              }
              throw new Error("ADS request failed with status: ".concat(response == null ? void 0 : response.status, " ").concat(response == null ? void 0 : response.statusText));
            case 9:
              _context2.next = 11;
              return response == null ? void 0 : response.json();
            case 11:
              result = _context2.sent;
              _context2.next = 14;
              return getHeader('matchreason', response.headers);
            case 14:
              matchReason = _context2.sent;
              _context2.next = 17;
              return getHeader('adrequestid', response.headers);
            case 17:
              adRequestId = _context2.sent;
              _context2.next = 20;
              return getHeader('adresponseid', response.headers);
            case 20:
              adResponseId = _context2.sent;
              parsedAds = result == null ? void 0 : result.map(function (item) {
                return (0,esm_extends/* default */.Z)({}, item, {
                  adRequestId: adRequestId,
                  adResponseId: adResponseId
                });
              });
              setHeadersResponse({
                adRequestId: adRequestId,
                adResponseId: adResponseId,
                matchReason: matchReason
              });
              setAdsResponse(parsedAds);
              _context2.next = 29;
              break;
            case 26:
              _context2.prev = 26;
              _context2.t0 = _context2["catch"](0);
              console.error("[useMagaluAds] - error: ".concat(_context2.t0));
            case 29:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 26]]);
      }));
      return function fetchAds() {
        return _ref3.apply(this, arguments);
      };
    }();
    fetchAds();
    return function () {
      setAdsResponse([]);
      setHeadersResponse({});
    };
  }, [JSON.stringify(route)]);
  return {
    adsResponse: adsResponse,
    headersResponse: headersResponse
  };
}
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MagaluAdsShowcase/parseAdsProducts.js
var parseAdsProduct = function parseAdsProduct(adsResponse) {
  return adsResponse == null ? void 0 : adsResponse.map(function (ads, index) {
    if (!ads) return null;
    return {
      adId: ads.adId,
      ads: {
        campaignId: ads.campaignId,
        id: ads.adId,
        sponsored: false
      },
      available: true,
      brand: {
        label: ads.brand
      },
      category: {
        name: ads.category
      },
      image: ads.imageUrl,
      path: '/',
      position: index + 1,
      price: {
        bestPrice: ads.publisherCustomFields.prices[0].best_price.total_amount,
        price: ads.publisherCustomFields.prices[0].price
      },
      rating: {
        count: Number(ads.reviewCount),
        score: Number(ads.reviewRating)
      },
      seller: {
        id: ads.sellerId
      },
      subcategory: {
        name: ads.subCategory
      },
      title: ads.name,
      url: ads.url
    };
  });
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MagaluAdsShowcase/parseSearchToAds.js

var parseSearchToAds = function parseSearchToAds(search) {
  if (!search) return undefined;
  var productsWithoutAds = [];
  for (var i = 0; i < search.length; i += 1) {
    var product = search[i];
    if (!product.ads) {
      var _product$brand, _product$category, _product$subcategory;
      productsWithoutAds.push({
        brand: slugify_default()((product == null ? void 0 : (_product$brand = product.brand) == null ? void 0 : _product$brand.label) || '').toLocaleLowerCase(),
        category: slugify_default()((product == null ? void 0 : (_product$category = product.category) == null ? void 0 : _product$category.name) || '').toLocaleLowerCase(),
        name: product.title,
        sku: product.id,
        subCategory: slugify_default()((product == null ? void 0 : (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.name) || '').toLocaleLowerCase()
      });
    }
    if (productsWithoutAds.length === 3) break;
  }
  return productsWithoutAds;
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MagaluAdsShowcase/MagaluAdsShowcase.js














var createSearchParams = function createSearchParams(adRequestId, useViewedProducts, viewedProducts, data, page, publisherId, slots, zipCode) {
  var _data$search, _data$search2, _data$search2$product;
  return {
    adRequestId: adRequestId,
    items: useViewedProducts ? parseSearchToAds(viewedProducts) : parseSearchToAds(data == null ? void 0 : (_data$search = data.search) == null ? void 0 : _data$search.products),
    page: page,
    publisherId: publisherId,
    skusOnPage: (data == null ? void 0 : (_data$search2 = data.search) == null ? void 0 : (_data$search2$product = _data$search2.products) == null ? void 0 : _data$search2$product.map(function (item) {
      return item.id;
    })) || undefined,
    slots: slots,
    zipCode: zipCode
  };
};
var createGetParams = function createGetParams(brand, category, title, id, slots, subcategory, zipCode) {
  return {
    brand: brand == null ? void 0 : brand.slug,
    category: slugify_default()((category == null ? void 0 : category.name) || '').toLowerCase(),
    name: title,
    sku: id,
    slots: slots,
    subCategory: slugify_default()((subcategory == null ? void 0 : subcategory.name) || '').toLowerCase(),
    zipCode: zipCode
  };
};
var MagaluAdsShowcase = function MagaluAdsShowcase(_ref) {
  var _window, _window$crypto, _structure$cookies, _structure$cookies$ac, _structure$route, _showcase$config, _showcase$config2, _structure$route2;
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    category = _ref2.category,
    subcategory = _ref2.subcategory,
    id = _ref2.id,
    title = _ref2.title,
    brand = _ref2.brand,
    seller = _ref2.seller;
  var _ref3 = (structure == null ? void 0 : structure.cookies) || {},
    customerId = _ref3.customerId,
    location = _ref3.location;
  var channel = staticProps.channel,
    publisherId = staticProps.publisherId,
    page = staticProps.page,
    slots = staticProps.slots,
    _staticProps$carousel = staticProps.carouselConfig,
    carouselConfig = _staticProps$carousel === void 0 ? {} : _staticProps$carousel,
    _staticProps$showcase = staticProps.showcase,
    showcase = _staticProps$showcase === void 0 ? {} : _staticProps$showcase,
    exhibition = staticProps.exhibition,
    adsPlacement = staticProps.adsPlacement,
    pathAds = staticProps.pathAds,
    method = staticProps.method,
    contentType = staticProps.contentType,
    placement = staticProps.placement,
    titleAs = staticProps.titleAs,
    productTitleAs = staticProps.productTitleAs,
    term = staticProps.term,
    jsonLD = staticProps.jsonLD,
    showInCashLabel = staticProps.showInCashLabel,
    showDiscount = staticProps.showDiscount,
    showDiscountOnlyCashInfo = staticProps.showDiscountOnlyCashInfo,
    useViewedProducts = staticProps.useViewedProducts;
  var ref = (0,react.useRef)(null);
  var zipCode = (location == null ? void 0 : location.zipCode) || '';
  var viewedProducts = [];
  if (esm/* whereAmI.onClient */.er.onClient) {
    var _get;
    var _useStorage = (0,esm/* useStorage */.y$)('viewing-history'),
      get = _useStorage.get;
    viewedProducts = ((_get = get()) == null ? void 0 : _get.items) || [];
  }
  var adRequestId = esm/* whereAmI.onClient */.er.onClient ? (_window = window) == null ? void 0 : (_window$crypto = _window.crypto) == null ? void 0 : _window$crypto.randomUUID == null ? void 0 : _window$crypto.randomUUID() : (crypto_browserify_default()) == null ? void 0 : (crypto_browserify_default()).randomUUID == null ? void 0 : crypto_browserify_default().randomUUID();
  var headers = new Headers({
    adRequestId: adRequestId,
    channel: channel,
    'Content-Type': contentType,
    publisherId: publisherId
  });
  var searchParams = createSearchParams(adRequestId, useViewedProducts, viewedProducts, data, page, publisherId, slots, zipCode);
  var getParams = createGetParams(brand, category, title, id, slots, subcategory, zipCode);
  var _useAdsData = useAdsData({
      adsUrl: new URL(ADS_URL + pathAds),
      headers: headers,
      method: method,
      params: method !== 'GET' ? searchParams : getParams,
      structure: structure
    }),
    adsResponse = _useAdsData.adsResponse,
    headersResponse = _useAdsData.headersResponse;
  var products = parseAdsProduct(adsResponse);
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var eventData = {
    customer_id: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id,
    display: 'gallery',
    filters: structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.filters,
    list: showcase == null ? void 0 : (_showcase$config = showcase.config) == null ? void 0 : _showcase$config.title,
    origin: "ads:".concat(placement),
    pageName: structure == null ? void 0 : structure.name,
    showcase: {
      placeId: placement,
      title: showcase == null ? void 0 : (_showcase$config2 = showcase.config) == null ? void 0 : _showcase$config2.title,
      type: exhibition
    },
    term: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term,
    type: 'recomendacao'
  };
  var handleProductView = function handleProductView(product) {
    publish('product:view', (0,esm_extends/* default */.Z)({}, eventData, {
      listPosition: product.index + 1,
      product: (0,esm_extends/* default */.Z)({}, product, {
        position: product.index + 1
      })
    }));
    publish('product:viewItemList', (0,esm_extends/* default */.Z)({}, eventData, product));
  };
  var handleProductClick = function handleProductClick(e, product) {
    publish('productlist:selectItem:click', (0,esm_extends/* default */.Z)({}, eventData, product));
    publish('productlist:click', (0,esm_extends/* default */.Z)({}, eventData, {
      listPosition: product.index + 1
    }, product));
  };
  (0,react.useEffect)(function () {
    if (adsResponse && (adsResponse == null ? void 0 : adsResponse.length)) {
      var product = {
        brand: brand == null ? void 0 : brand.slug,
        category: category == null ? void 0 : category.name,
        genders: [''],
        name: title,
        seller: seller == null ? void 0 : seller.id,
        sku: id,
        subCategory: subcategory == null ? void 0 : subcategory.name
      };
      var context = (0,esm_extends/* default */.Z)({
        adRequestId: headersResponse == null ? void 0 : headersResponse.adRequestId,
        adResponseId: headersResponse == null ? void 0 : headersResponse.adResponseId,
        adsRequestedCount: slots,
        adsReturnedCount: adsResponse == null ? void 0 : adsResponse.length,
        channel: channel,
        matchReason: headersResponse == null ? void 0 : headersResponse.matchReason,
        page: page,
        placement: adsPlacement,
        publisherId: publisherId,
        searchTerm: term || '',
        target: ref == null ? void 0 : ref.current,
        userId: customerId || '1234_anonymous2',
        userTrackId: customerId || '12345_anonymous',
        zipcode: (location == null ? void 0 : location.zipCode) || ''
      }, product);
      (0,useAdsSdk/* default */.Z)(context, adsResponse);
    }
  }, [adsResponse]);
  return react.createElement(react.Fragment, null, !!(products == null ? void 0 : products.length) && react.createElement(Showcase/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    key: "showcase-1",
    exhibition: exhibition,
    data: (0,esm_extends/* default */.Z)({}, showcase == null ? void 0 : showcase.config, {
      products: products
    }),
    jsonLD: jsonLD,
    titleAs: titleAs,
    productTitleAs: productTitleAs,
    showInCashInfo: showInCashLabel,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo
  }, carouselConfig, {
    showSponsoredSubTitle: true,
    onProductView: handleProductView,
    onClick: handleProductClick
  }, carouselConfig)));
};
 false ? 0 : void 0;
MagaluAdsShowcase.defaultProps = {
  data: {},
  "static": {
    channel: 'WEB',
    exhibition: 'carousel',
    name: MagaluAdsShowcase,
    page: 'SHOWCASE',
    placement: '',
    publisherId: 'magazineluiza',
    slots: 5,
    useViewedProducts: false
  },
  structure: {}
};
MagaluAdsShowcase.ssr = true;
/* harmony default export */ var MagaluAdsShowcase_MagaluAdsShowcase = ((0,withLayoutProps/* default */.Z)(MagaluAdsShowcase));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MagaluAdsShowcase/index.js


/***/ }),

/***/ 518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MediaGallery_MediaGallery; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/index.js + 4 modules
var organisms_MediaGallery = __webpack_require__(60857);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MediaGallery/MediaGallery.styles.js

var _templateObject;


var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.getBackgroundColor)('lighter')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MediaGallery/MediaGallery.js




var _excluded = ["media"];








var MediaGallery = function MediaGallery(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _data$product = data.product,
    media = _data$product.media,
    product = (0,objectWithoutProperties/* default */.Z)(_data$product, _excluded);
  var audios = [].concat((0,toConsumableArray/* default */.Z)((media == null ? void 0 : media.audios) || []), (0,toConsumableArray/* default */.Z)((media == null ? void 0 : media.podcasts) || []));
  var imgWidth = staticProps.imgWidth,
    imgHeight = staticProps.imgHeight,
    imgMaxHeight = staticProps.imgMaxHeight,
    mediaGalleryModal = staticProps.mediaGalleryModal,
    preload = staticProps.preload,
    showThumbnail = staticProps.showThumbnail;
  var mediaGalleryAlt = "Imagem de ".concat(product.title);
  var fullTitle = (0,esm/* getFullTitle */.HV)(product);
  var _ref2 = (media == null ? void 0 : media.images) || [],
    _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
    firstMedia = _ref3[0];
  var src = (0,esm/* replaceSizeImage */.oP)({
    imgHeight: imgHeight,
    imgWidth: imgWidth,
    src: firstMedia
  });
  var handleImageClick = function handleImageClick(idx) {
    if (mediaGalleryModal) {
      var _media$videos;
      var videos = (media == null ? void 0 : (_media$videos = media.videos) == null ? void 0 : _media$videos.length) || 0;
      var podcasts = (audios == null ? void 0 : audios.length) || 0;
      var selectedImageIdx = idx < 0 ? 0 : idx;
      var mediaImageIdx = videos + podcasts + selectedImageIdx;
      publish('mediagallerymodal:toggle', mediaImageIdx);
    }
  };
  var handleMediaClick = function handleMediaClick(type) {
    if (mediaGalleryModal) {
      var _media$videos2;
      var mediaTypes = {
        audio: (media == null ? void 0 : (_media$videos2 = media.videos) == null ? void 0 : _media$videos2.length) + 0,
        video: 0
      };
      publish('mediagallerymodal:toggle', mediaTypes[type]);
    }
  };
  return react.createElement(Container, null, preload && src && react.createElement((head_default()), null, react.createElement("link", {
    rel: "preload",
    as: "image",
    href: src
  })), react.createElement(organisms_MediaGallery/* default */.Z, (0,esm_extends/* default */.Z)({
    lazy: true,
    m: ['0 8px', '0px'],
    alt: mediaGalleryAlt,
    title: fullTitle,
    imgWidth: imgWidth,
    imgHeight: imgHeight,
    imgMaxHeight: imgMaxHeight,
    showThumbnail: showThumbnail,
    preload: preload,
    onImageClick: handleImageClick,
    onVideoClick: function onVideoClick() {
      return handleMediaClick('video');
    },
    onAudioClick: function onAudioClick() {
      return handleMediaClick('audio');
    }
  }, media)));
};
 false ? 0 : void 0;
MediaGallery.defaultProps = {
  data: {},
  "static": {}
};
MediaGallery.ssr = true;
MediaGallery.displayName = 'MediaGallery';
/* harmony default export */ var MediaGallery_MediaGallery = ((0,withLayoutProps/* default */.Z)(MediaGallery));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MediaGallery/index.js


/***/ }),

/***/ 44485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MediaGalleryModal_MediaGalleryModal; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/index.js + 4 modules
var Carousel = __webpack_require__(49542);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/index.js + 2 modules
var HorizontalRule = __webpack_require__(97600);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ProductInfoBar/index.js + 2 modules
var ProductInfoBar = __webpack_require__(8758);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(282);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MediaGalleryModal/useZoom.js



var zoomMiddle = function zoomMiddle(value) {
  return value * 0.25 * -1;
};
function useZoom(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width;
  var initialZoomPosition = {
    clientX: zoomMiddle(width),
    clientY: zoomMiddle(height)
  };
  var _useState = (0,react.useState)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    zoom = _useState2[0],
    setZoom = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    zoomCoords = _useState4[0],
    setZoomCoords = _useState4[1];
  var _useState5 = (0,react.useState)(false),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    zoomDragging = _useState6[0],
    setZoomDragging = _useState6[1];
  var _useState7 = (0,react.useState)(false),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    zoomMoved = _useState8[0],
    setZoomMoved = _useState8[1];
  var _useState9 = (0,react.useState)(initialZoomPosition),
    _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
    zoomPosition = _useState10[0],
    setZoomPosition = _useState10[1];
  var handleMove = (0,react.useCallback)(debounce_default()(function (e) {
    if (!zoomDragging) return;
    if (!zoomMoved) setZoomMoved(true);
    setZoomPosition(function (prev) {
      var newX = prev.clientX + (e.clientX - zoomCoords.clientX);
      var newY = prev.clientY + (e.clientY - zoomCoords.clientY);
      var clientX = e.clientX,
        clientY = e.clientY;
      setZoomCoords({
        clientX: clientX,
        clientY: clientY
      });
      return {
        clientX: newX,
        clientY: newY
      };
    });
  }, 1), [zoomCoords, zoomDragging, zoomMoved]);
  var handleDown = (0,react.useCallback)(function (e, isZoomActive) {
    if (isZoomActive) {
      setZoomDragging(true);
      var clientX = e.clientX,
        clientY = e.clientY;
      setZoomCoords({
        clientX: clientX,
        clientY: clientY
      });
    }
  }, []);
  var handleUp = (0,react.useCallback)(function (isZoomActive, idx) {
    setZoomDragging(false);
    if (zoomMoved) return setZoomMoved(false);
    if (isZoomActive) {
      setZoomPosition(initialZoomPosition);
      return setZoom(null);
    }
    return setZoom(idx);
  }, [zoomMoved]);
  var handleLeave = (0,react.useCallback)(function () {
    return setZoomDragging(false);
  }, []);
  return {
    handleDown: handleDown,
    handleLeave: handleLeave,
    handleMove: handleMove,
    handleUp: handleUp,
    setZoom: setZoom,
    zoom: zoom,
    zoomDragging: zoomDragging,
    zoomPosition: zoomPosition
  };
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/BaseButton/index.js + 1 modules
var BaseButton = __webpack_require__(66685);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MediaGalleryModal/MediaGalleryModal.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;




var GalleryImagesContainer = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-width: 65%;\n  max-height: 650px;\n  height: 64%;\n"])));
var GalleryThumbButton = (0,styled_components_browser_esm["default"])(BaseButton/* default */.Z).attrs({
  role: 'tab'
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border: 1px solid;\n  border-color: ", ";\n  max-height: 85px;\n  max-width: 96px;\n  margin: 0 1.5rem 1.5rem 0.5rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  img {\n    max-width: 90%;\n  }\n"])), function (props) {
  return props.active ? (0,stereo_ui_styles_build_esm.getBackgroundColor)('primary')(props) : 'transparent';
}, function (_ref) {
  var isImage = _ref.isImage;
  return isImage ? '2px' : '8px';
});
var PodcastAudio = styled_components_browser_esm["default"].audio(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
var PodcastImage = styled_components_browser_esm["default"].img(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  height: 193px;\n  margin-bottom: 1rem;\n  width: 193px;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.getBackgroundColor)('luContentPrimary')(props);
});
var ZoomContainer = styled_components_browser_esm["default"].div(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  margin: 0 auto;\n"])));
var ZoomImage = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: ", ";\n  max-height: 650px;\n\n  ", "\n"])), function (props) {
  return props.activeZoom ? 'grab' : 'zoom-in';
}, function (props) {
  return props.activeZoom ? (0,styled_components_browser_esm.css)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n          height: 1500px;\n          max-height: none;\n          width: 1500px;\n        "]))) : (0,styled_components_browser_esm.css)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n          height: 400px;\n          width: 600px;\n        "])));
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MediaGalleryModal/MediaGalleryModal.js



var _excluded = ["media"];
















var imgHeight = 1500;
var imgWidth = 1500;
var thumbImgHeight = 74;
var thumbImgWidth = 96;
var MediaGalleryModal = function MediaGalleryModal(_ref) {
  var data = _ref.data,
    modalOpen = _ref.open,
    structure = _ref.structure,
    staticProps = _ref["static"];
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useState = (0,react.useState)(modalOpen),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0,react.useState)(0),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    activeImage = _useState4[0],
    setActiveImage = _useState4[1];
  var _useState5 = (0,react.useState)({
      height: 'auto',
      width: 'auto'
    }),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    zoomContainerSize = _useState6[0],
    setZoomContainerSize = _useState6[1];
  var _useZoom = useZoom({
      height: imgHeight,
      width: imgWidth
    }),
    handleDown = _useZoom.handleDown,
    handleLeave = _useZoom.handleLeave,
    handleMove = _useZoom.handleMove,
    handleUp = _useZoom.handleUp,
    setZoom = _useZoom.setZoom,
    zoom = _useZoom.zoom,
    zoomDragging = _useZoom.zoomDragging,
    zoomPosition = _useZoom.zoomPosition;
  var thumbsPerColumn = staticProps.thumbsPerColumn;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    media = _ref2.media,
    product = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);
  var images = (media == null ? void 0 : media.images) || [];
  var videosDefault = (media == null ? void 0 : media.videos) || [];
  var podcastsDefault = (media == null ? void 0 : media.podcasts) || [];
  var _useState7 = (0,react.useState)(videosDefault),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    videos = _useState8[0],
    setVideos = _useState8[1];
  var _useState9 = (0,react.useState)(podcastsDefault),
    _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
    podcasts = _useState10[0],
    setPodcasts = _useState10[1];
  var thumbsFormatted = (0,build_esm/* getThumbsFormatted */.b7)(videos, podcasts, images, thumbsPerColumn);
  var handleClickEvent = (0,react.useCallback)(function (imageIndex) {
    setVideos(open ? [] : videosDefault);
    setPodcasts(open ? [] : podcastsDefault);
    setOpen(!open);
    setActiveImage(imageIndex || 0);
  }, [open]);
  (0,react.useEffect)(function () {
    subscribe('mediagallerymodal:toggle', handleClickEvent);
    return function () {
      unsubscribe('mediagallerymodal:toggle', handleClickEvent);
    };
  }, []);
  (0,react.useEffect)(function () {
    if (!open) {
      setZoom(null);
    }
  }, [open]);
  return react.createElement(react.Fragment, null, react.createElement(Dialog/* default */.Z, {
    onClickOutside: handleClickEvent,
    height: "100%",
    bg: "background.white",
    position: "center",
    type: "dialog",
    visible: open,
    portal: true,
    showClose: true,
    title: react.createElement(ProductInfoBar/* default */.Z, {
      data: data,
      structure: structure,
      "static": staticProps
    }),
    titleStyle: {
      alignItems: 'center',
      columnGap: 4,
      forwardedAs: Flex/* default */.Z,
      width: 'calc(100% - 32px)'
    }
  }, react.createElement(HorizontalRule/* default */.Z, null), react.createElement(Grid/* default */.Z, {
    mt: 4,
    gridGap: "0 1rem",
    gridTemplateColumns: "1fr 4fr",
    height: "78%"
  }, react.createElement(Carousel/* default */.Z, {
    auto: false,
    slidesPerView: 2
  }, thumbsFormatted.map(function (list) {
    var _list$;
    return react.createElement(Flex/* default */.Z, {
      key: (_list$ = list[0]) == null ? void 0 : _list$.id,
      role: "tablist",
      flexDirection: "column",
      flexWrap: "wrap",
      paddingTop: "0.5rem",
      alignItems: list.length <= thumbsPerColumn ? 'center' : 'initial'
    }, list.map(function (_ref3) {
      var id = _ref3.id,
        type = _ref3.type,
        link = _ref3.link;
      if (type === 'video') {
        return react.createElement(GalleryThumbButton, {
          active: activeImage === id,
          "aria-label": "Selecionar V\xEDdeo",
          "aria-selected": activeImage === id,
          key: "thumb-".concat(link),
          onClick: function onClick() {
            return setActiveImage(id);
          },
          isImage: false
        }, react.createElement(esm/* Icon */.JO$, {
          name: "VideoCircle"
        }), react.createElement(Text/* default */.Z, {
          color: "luContentLink"
        }, "V\xEDdeo"));
      }
      if (type === 'podcast') {
        return react.createElement(GalleryThumbButton, {
          active: activeImage === id,
          "aria-label": "Selecionar Dica em \xE1udio",
          "aria-selected": activeImage === id,
          key: "thumb-".concat(link),
          onClick: function onClick() {
            return setActiveImage(id);
          },
          isImage: false
        }, react.createElement(esm/* Icon */.JO$, {
          name: "PodcastCircle"
        }), react.createElement(Text/* default */.Z, {
          color: "luContentLink"
        }, "Dica"));
      }
      if (type === 'image') {
        return react.createElement(GalleryThumbButton, {
          active: activeImage === id,
          "aria-selected": activeImage === id,
          "aria-label": "Selecionar imagem",
          key: "thumb-".concat(link),
          onClick: function onClick() {
            return setActiveImage(id);
          },
          isImage: true
        }, react.createElement(ResponsiveImage/* default */.Z, {
          alt: "Imagem miniatura de ".concat(product.title),
          height: thumbImgHeight,
          src: link,
          width: thumbImgWidth
        }));
      }
      return null;
    }));
  })), react.createElement(GalleryImagesContainer, null, react.createElement(Carousel/* default */.Z, {
    auto: false,
    goTo: activeImage,
    lazy: true,
    showArrowControls: true,
    showControls: false,
    onChange: setActiveImage
  }, videos.map(function (video) {
    var videoSrc = video.replace('http://', '//').replace('/v/', '/embed/');
    return react.createElement(Flex/* default */.Z, {
      alignItems: "center",
      flexDirection: "column",
      height: "100%",
      justifyContent: "center",
      key: "gallery-".concat(video)
    }, react.createElement("iframe", {
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true,
      frameBorder: "0",
      height: "100%",
      src: videoSrc,
      title: "YouTube video player",
      width: "95%"
    }));
  }), podcasts.map(function (podcast) {
    return react.createElement(Flex/* default */.Z, {
      alignItems: "center",
      flexDirection: "column",
      height: "100%",
      justifyContent: "center",
      key: "gallery-".concat(podcast)
    }, react.createElement(PodcastImage, {
      alt: "Imagem da Lu",
      src: "https://wx.mlcdn.com.br/site/shared/lu-content/lu-podcast.png",
      title: "Imagem da Lu"
    }), react.createElement(Text/* default */.Z, {
      color: "scratched",
      frontSize: 0
    }, "Clique abaixo para ouvir a dica"), react.createElement(PodcastAudio, {
      controls: true,
      preload: true
    }, react.createElement("source", {
      src: podcast,
      type: "audio/mpeg"
    }), react.createElement("caption", {
      style: {
        display: 'none'
      }
    }, product == null ? void 0 : product.title)));
  }), images.map(function (image, idx) {
    var isZoomActive = zoom === idx;
    return react.createElement(ZoomContainer, {
      "data-testid": "zoom-container",
      key: "gallery-".concat(image),
      style: (0,esm_extends/* default */.Z)({}, zoomContainerSize)
    }, react.createElement(ZoomImage, {
      activeZoom: isZoomActive,
      alt: "Imagem de ".concat(product.title),
      draggable: false,
      height: imgHeight,
      onLoad: function onLoad(e) {
        var _e$target = e.target,
          height = _e$target.offsetHeight,
          width = _e$target.offsetWidth;
        setZoomContainerSize({
          height: height,
          width: width
        });
      },
      onMouseMove: handleMove,
      onMouseDown: function onMouseDown(e) {
        return handleDown(e, isZoomActive);
      },
      onMouseUp: function onMouseUp() {
        return handleUp(isZoomActive, idx);
      },
      onMouseLeave: handleLeave,
      src: image,
      width: imgWidth,
      style: (0,esm_extends/* default */.Z)({}, isZoomActive ? {
        transform: "translate(".concat(zoomPosition.clientX, "px, ").concat(zoomPosition.clientY, "px)")
      } : {}, zoomDragging ? {
        cursor: 'grabbing'
      } : {})
    }));
  }))))));
};
 false ? 0 : void 0;
MediaGalleryModal.defaultProps = {
  data: {},
  open: false,
  "static": {
    thumbsPerColumn: 5
  },
  structure: {
    config: {
      cartUrl: {
        guarantee: ''
      }
    }
  }
};
MediaGalleryModal.ssr = false;
MediaGalleryModal.displayName = 'MediaGalleryModal';
/* harmony default export */ var MediaGalleryModal_MediaGalleryModal = ((0,withLayoutProps/* default */.Z)(MediaGalleryModal));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MediaGalleryModal/index.js


/***/ }),

/***/ 19069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MessageBox_MessageBox; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MessageBox/index.js + 2 modules
var molecules_MessageBox = __webpack_require__(28982);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MessageBox/MessageBox.styles.js

var _templateObject, _templateObject2, _templateObject3;




var Button = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function () {
  return {
    bg: 'transparent',
    fontSize: [0, 2, 2],
    fontWeight: 'bold',
    forwardedAs: 'button'
  };
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border: none;\n  color: ", ";\n  cursor: pointer;\n"])), function (props) {
  return (0,build_esm.getTextColor)('lightest')(props);
});
var MessageBox_styles_Link = (0,styled_components_browser_esm["default"])(Link/* default */.Z).attrs(function () {
  return {
    color: 'yellow',
    fontSize: [0, 2, 2],
    fontWeight: 'bold'
  };
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var MessageBox_styles_Text = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function () {
  return {
    color: 'lightest',
    fontSize: [0, 2, 2],
    fontWeight: 'bold'
  };
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MessageBox/MessageBox.js







var MessageBox = function MessageBox(_ref) {
  var staticProps = _ref["static"];
  var _useState = (0,react.useState)(true),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    messageShow = _useState2[0],
    setMessageShow = _useState2[1];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var hrefLink = staticProps.hrefLink,
    text = staticProps.text,
    textButton = staticProps.textButton,
    textLink = staticProps.textLink;
  var onClickButton = function onClickButton() {
    publish('addtoacceptpolity:success');
    setMessageShow(false);
  };
  return messageShow && react.createElement(molecules_MessageBox/* default */.Z, null, react.createElement(Flex/* default */.Z, {
    justifyContent: "center",
    width: ['90%', '60%', '60%']
  }, react.createElement(MessageBox_styles_Text, null, text, react.createElement(MessageBox_styles_Link, {
    href: hrefLink,
    target: "_blank",
    rel: "noopener"
  }, textLink))), react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    justifyContent: ['flex-end', 'center', 'center'],
    mt: [1, 0, 0]
  }, react.createElement(Button, {
    "data-testid": "button-message-box",
    onClick: onClickButton
  }, textButton)));
};
 false ? 0 : void 0;
MessageBox.defaultProps = {
  "static": {}
};
MessageBox.ssr = true;
/* harmony default export */ var MessageBox_MessageBox = (MessageBox);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MessageBox/index.js


/***/ }),

/***/ 24275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ metaNoIndex; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MetaNoIndex/metaNoIndex.js



var MetaNoIndex = function MetaNoIndex(_ref) {
  var data = _ref.data;
  var sensitiveTerm = data == null ? void 0 : data.sensitiveTerm;
  var shouldSetNoIndex = sensitiveTerm && sensitiveTerm.setNoIndex === true ? 'noindex' : 'index';
  return react.createElement((head_default()), null, react.createElement("meta", {
    "data-testid": "meta-no-index",
    name: "robots",
    content: shouldSetNoIndex
  }));
};
MetaNoIndex.displayName = 'MetaNoIndex';
MetaNoIndex.defaultProps = {
  data: {}
};
 false ? 0 : void 0;
MetaNoIndex.ssr = true;
/* harmony default export */ var metaNoIndex = (MetaNoIndex);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MetaNoIndex/index.js


/***/ }),

/***/ 61553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MinimumOrderQuantity_MinimumOrderQuantity; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MinimumOrderQuantity/MinimumOrderQuantity.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4;


var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0 16px 8px;\n  ", "\n"])), function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && (0,styled_components_browser_esm.css)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding: 0;\n      margin: 15px 12px;\n    "])));
});
var Label = styled_components_browser_esm["default"].label(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 65%;\n  width: 100%;\n  height: 20px;\n  padding: 13px 0;\n  border: 0.5px solid #ccac00;\n  background-color: #fffdf0;\n  color: ", ";\n  border-radius: 8px;\n  flex-wrap: nowrap;\n  font-size: 16px;\n  ", "\n"])), function (props) {
  return (0,esm.getTextColor)('base')(props);
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && (0,styled_components_browser_esm.css)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      justify-content: flex-start;\n      padding: 15px 0px 15px 13px;\n    "])));
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MinimumOrderQuantity/MinimumOrderQuantity.js




var MinimumOrderQuantity = function MinimumOrderQuantity(_ref) {
  var _data$product;
  var data = _ref.data,
    staticProps = _ref["static"];
  var mobile = staticProps == null ? void 0 : staticProps.isMobile;
  var minimumQuantity = data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.minimumOrderQuantity;
  return react.createElement(react.Fragment, null, react.createElement(Container, {
    "data-testid": "product-minimum-container",
    isMobile: mobile
  }, react.createElement(Box/* default */.Z, {
    width: ['100%', '100%', '65%']
  }, react.createElement(Label, {
    isMobile: mobile,
    "data-testid": "product-minimum"
  }, "Quantidade m\xEDnima: ".concat(minimumQuantity, " unidades")))));
};
 false ? 0 : void 0;
MinimumOrderQuantity.defaultProps = {
  data: {},
  "static": (0,prop_types.shape)({
    isMobile: false
  })
};
MinimumOrderQuantity.ssr = true;
/* harmony default export */ var MinimumOrderQuantity_MinimumOrderQuantity = (MinimumOrderQuantity);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/MinimumOrderQuantity/index.js


/***/ }),

/***/ 36826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Newsletter_Newsletter; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Newsletter/Newsletter.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;






var Container = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  background-color: ", ";\n  border-radius: 8px;\n  gap: 25px;\n"])), function (props) {
  return props.bgColor || (0,stereo_ui_styles_build_esm.getBackgroundColor)('primary');
});
var Form = styled_components_browser_esm["default"].form(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  ", "\n"])), index_esm.flexbox);
var Image = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: inherit;\n  width: 130px;\n  height: 112px;\n"])));
var InputField = (0,styled_components_browser_esm["default"])(Input/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 44px;\n"])));
var Small = styled_components_browser_esm["default"].small(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: ", "px;\n  color: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('space.1')(props);
}, (0,stereo_ui_styles_build_esm.getTextColor)('lightest'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Newsletter/constants.js
var DEFAULT = 'default';
var EMAILREGEX = /^\S{1,65}@{1,1}\S{1,20}\.\S{2,5}$/;
var ERROR = 'error';
var SUCCESS = 'success';
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Newsletter/Newsletter.js





var _excluded = ["origin"];
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }












var validateEmail = function validateEmail(value) {
  if (value && EMAILREGEX.test(value)) {
    return true;
  }
  return false;
};
var validateName = function validateName(value) {
  if (value && value.length > 2) {
    return true;
  }
  return false;
};
var Newsletter = function Newsletter(_ref) {
  var _template$image, _template$image2, _template$image3, _template$image4, _template$image5, _template$image6, _template$link, _template$link2, _template$link3;
  var _ref$static = _ref["static"],
    origin = _ref$static.origin,
    staticProps = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded);
  var _useNewsletter = (0,build_esm.useNewsletter)(),
    subscribeToNewsletter = _useNewsletter.subscribeToNewsletter,
    loading = _useNewsletter.loading;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useState = (0,react.useState)(staticProps),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    template = _useState2[0],
    setTemplate = _useState2[1];
  var _useState3 = (0,react.useState)(DEFAULT),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    templateKey = _useState4[0],
    setTemplateKey = _useState4[1];
  var _useState5 = (0,react.useState)({
      error: false,
      value: ''
    }),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    name = _useState6[0],
    setName = _useState6[1];
  var _useState7 = (0,react.useState)({
      error: false,
      value: ''
    }),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    email = _useState8[0],
    setEmail = _useState8[1];
  var invalidName = staticProps.invalidName,
    invalidEmail = staticProps.invalidEmail;
  (0,react.useEffect)(function () {
    setTemplate(staticProps[templateKey]);
  }, [staticProps, templateKey]);
  var handleSubmit = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(event) {
      var validName, validEmail, _yield$subscribeToNew, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            validName = validateName(name == null ? void 0 : name.value);
            validEmail = validateEmail(email == null ? void 0 : email.value);
            setName(function (curr) {
              return (0,esm_extends/* default */.Z)({}, curr, {
                error: !validName
              });
            });
            setEmail(function (curr) {
              return (0,esm_extends/* default */.Z)({}, curr, {
                error: !validEmail
              });
            });
            if (!(validName && validEmail)) {
              _context.next = 14;
              break;
            }
            _context.next = 8;
            return subscribeToNewsletter({
              email: email == null ? void 0 : email.value,
              name: name == null ? void 0 : name.value,
              origin: origin
            });
          case 8:
            _yield$subscribeToNew = _context.sent;
            error = _yield$subscribeToNew.error;
            if (!error) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", setTemplateKey(ERROR));
          case 12:
            publish('newsletter:success', {
              email: email == null ? void 0 : email.value,
              name: name == null ? void 0 : name.value,
              origin: 'cr'
            });
            return _context.abrupt("return", setTemplateKey(SUCCESS));
          case 14:
            return _context.abrupt("return", null);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return react.createElement(Container, {
    bgColor: staticProps.bgColor
  }, react.createElement(Flex/* default */.Z, {
    alignItems: "center"
  }, react.createElement(Image, {
    src: template == null ? void 0 : (_template$image = template.image) == null ? void 0 : _template$image.src,
    width: template == null ? void 0 : (_template$image2 = template.image) == null ? void 0 : _template$image2.width,
    height: template == null ? void 0 : (_template$image3 = template.image) == null ? void 0 : _template$image3.height,
    maxWidth: template == null ? void 0 : (_template$image4 = template.image) == null ? void 0 : _template$image4.width,
    maxHeight: template == null ? void 0 : (_template$image5 = template.image) == null ? void 0 : _template$image5.height,
    alt: template == null ? void 0 : (_template$image6 = template.image) == null ? void 0 : _template$image6.alt,
    imageWidth: "130px",
    imageHeight: "112px",
    lazy: true
  })), react.createElement(Flex/* default */.Z, {
    flex: 2,
    flexDirection: "column",
    justifyContent: "center",
    gap: 3,
    py: 3
  }, react.createElement(Text/* default */.Z, {
    as: "span",
    color: "lightest",
    fontSize: 5,
    fontWeight: "medium",
    "data-testid": "newsletter-title"
  }, template == null ? void 0 : template.title), react.createElement(Text/* default */.Z, {
    as: "span",
    color: "lightest",
    fontSize: 2,
    fontWeight: "regular",
    lineHeight: 1.2,
    "data-testid": "newsletter-description"
  }, template == null ? void 0 : template.description), (template == null ? void 0 : (_template$link = template.link) == null ? void 0 : _template$link.text) && react.createElement(Link/* default */.Z, {
    href: template == null ? void 0 : (_template$link2 = template.link) == null ? void 0 : _template$link2.href,
    color: "text.lightest",
    underline: true,
    p: 0,
    fontWeight: "medium",
    "data-testid": "newsletter-link"
  }, template == null ? void 0 : (_template$link3 = template.link) == null ? void 0 : _template$link3.text)), templateKey === ERROR && react.createElement(Flex/* default */.Z, {
    justifyContent: "flex-end",
    alignItems: "center"
  }, react.createElement(Button/* default */.Z, {
    color: "secondary",
    mr: 4,
    onClick: function onClick() {
      return setTemplateKey(DEFAULT);
    },
    "data-testid": "newsletter-error-button"
  }, "Tentar novamente")), templateKey === DEFAULT && react.createElement(Form, {
    onSubmit: handleSubmit,
    justifyContent: "space-around",
    flex: 4,
    "data-testid": "newsletter-form"
  }, react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    justifyContent: "center",
    width: "280px"
  }, react.createElement(InputField, {
    type: "text",
    placeholder: "Digite seu nome",
    onChange: function onChange(e) {
      return setName(function (curr) {
        return (0,esm_extends/* default */.Z)({}, curr, {
          value: e.target.value
        });
      });
    },
    "data-testid": "newsletter-input-name"
  }), (name == null ? void 0 : name.error) && react.createElement(Small, {
    "data-testid": "newsletter-name-helper"
  }, invalidName)), react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    justifyContent: "center",
    width: "280px"
  }, react.createElement(InputField, {
    type: "email",
    placeholder: "Digite seu e-mail",
    onChange: function onChange(e) {
      return setEmail(function (curr) {
        return (0,esm_extends/* default */.Z)({}, curr, {
          value: e.target.value
        });
      });
    },
    "data-testid": "newsletter-input-email"
  }), (email == null ? void 0 : email.error) && react.createElement(Small, {
    "data-testid": "newsletter-email-helper"
  }, invalidEmail)), react.createElement(Flex/* default */.Z, {
    alignItems: "center"
  }, react.createElement(Button/* default */.Z, {
    disabled: !(name == null ? void 0 : name.value) || !(email == null ? void 0 : email.value),
    color: "primary",
    type: "submit",
    "data-testid": "newsletter-submit"
  }, loading ? react.createElement(esm/* Icon */.JO$, {
    name: "AnimatedLoading3"
  }) : 'Cadastrar'))));
};
 false ? 0 : void 0;
Newsletter.defaultProps = {
  "static": {}
};
Newsletter.ssr = false;
/* harmony default export */ var Newsletter_Newsletter = ((0,withLayoutProps/* default */.Z)(Newsletter));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Newsletter/index.js


/***/ }),

/***/ 94559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ OfferTimer_OfferTimer; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/OfferTimer/OfferTimer.js




var OfferTimer = function OfferTimer(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data;
  var height = staticProps.height,
    fontSize = staticProps.fontSize,
    bg = staticProps.bg;
  var _ref2 = data.product || {},
    restrictions = _ref2.restrictions;
  return react.createElement(molecules/* OfferTimer */.dV, {
    height: height,
    fontSize: fontSize,
    restrictions: restrictions,
    bg: bg
  });
};
 false ? 0 : void 0;
OfferTimer.defaultProps = {
  data: {
    product: {
      restrictions: {}
    }
  },
  "static": {}
};
OfferTimer.ssr = true;
OfferTimer.displayName = 'OfferTimer';
/* harmony default export */ var OfferTimer_OfferTimer = ((0,withLayoutProps/* default */.Z)(OfferTimer));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/OfferTimer/index.js


/***/ }),

/***/ 44506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ OrderEligibleList_OrderEligibleList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/next/config.js
var next_config = __webpack_require__(70314);
var config_default = /*#__PURE__*/__webpack_require__.n(next_config);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ConfirmDialog/index.js + 2 modules
var ConfirmDialog = __webpack_require__(47562);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/OrderEligibleList/OrderEligibleList.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;










var ArrowBox = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 24px;\n  height: 24px;\n  margin-left: auto;\n"])));
var ArrowIcon = (0,styled_components_browser_esm["default"])(esm/* Icon */.JO$).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    position: 'relative'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
var ButtonSeeMore = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 24px 0px;\n"])));
var ContainerIcon = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: -62px;\n  margin-top: -20px;\n"])));
var Image = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z).attrs(function (props) {
  return {
    border: '1px solid #dbe0e1',
    borderRadius: 4,
    imageHeight: props.imageHeight && props.imageHeight.trim() !== '' ? props.imageHeight : '66px',
    imageWidth: props.imageWidth && props.imageWidth.trim() !== '' ? props.imageWidth : '66px',
    overflow: 'hidden'
  };
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 100%;\n  max-height: 100%;\n"])));
var ImageBox = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    height: '66px',
    padding: '9px',
    width: '66px'
  }, props);
})(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-width: 66px;\n  @media (max-width: 992px) {\n    min-width: 58px;\n    width: 58px;\n  }\n"])));
var LinkContainer = (0,styled_components_browser_esm["default"])(Link/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    bg: 'background.lighter',
    borderRadius: '16px',
    gap: 2,
    marginBottom: 2
  }, props);
})(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  height: 90px;\n  padding: 8px 16px;\n  @media (max-width: 992px) {\n    height: 64px;\n  }\n"])));
var PageContainer = (0,styled_components_browser_esm["default"])(Grid/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    marginLeft: 3,
    marginRight: 3
  }, props);
})(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-flow: column;\n  height: calc(100vh - 75px);\n"])));
var ProductTitle = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: '#51585c',
    fontSize: 1,
    fontStyle: 'normal',
    marginTop: 0,
    maxWidth: '100%'
  }, props);
})(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  line-height: 21px;\n  max-height: 48px;\n  -webkit-line-clamp: 2;\n  flex-direction: column;\n"])));
var TextContainer = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'flex-start',
    flexDirection: 'column',
    textAlign: 'left'
  }, props);
})(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var TextEmptyMessage = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 24px 0px;\n  color: #8c8c8c;\n  text-align: center;\n"])));
var Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  font-weight: 500;\n  margin: 24px 0px;\n  line-height: 32px;\n"])), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.5'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/OrderEligibleList/utils/getProductUrl.js
var getProductUrl = function getProductUrl(baseFinancialServiceUrl, productSku, subOrderUUID) {
  return "".concat(baseFinancialServiceUrl, "&sku=").concat(productSku, "&subOrderUUID=").concat(subOrderUUID);
};
/* harmony default export */ var utils_getProductUrl = (getProductUrl);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/OrderEligibleList/utils/getServiceSlug.js
var getServiceSlug = function getServiceSlug(factsheet) {
  var _factsheet$find, _factsheet$find$eleme, _factsheet$find$eleme2;
  return (factsheet == null ? void 0 : (_factsheet$find = factsheet.find(function (item) {
    return (item == null ? void 0 : item.slug) === 'ficha-tecnica';
  })) == null ? void 0 : (_factsheet$find$eleme = _factsheet$find.elements.find(function (item) {
    return (item == null ? void 0 : item.keyName) === 'Seguro';
  })) == null ? void 0 : (_factsheet$find$eleme2 = _factsheet$find$eleme.elements[0]) == null ? void 0 : _factsheet$find$eleme2.value) || '';
};
/* harmony default export */ var utils_getServiceSlug = (getServiceSlug);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/OrderEligibleList/utils/replaceTitle.js
var replaceTitle = function replaceTitle(text) {
  var productTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return text.replace('{{product.title}}', productTitle);
};
/* harmony default export */ var utils_replaceTitle = (replaceTitle);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/OrderEligibleList/utils/subtractMonths.js
var moment = __webpack_require__(19034);
var subtractMonths = function subtractMonths(date, months) {
  var momentDate = moment(date, 'YYYY-MM-DD HH:mm:ss.SSS');
  var originalDay = momentDate.date();
  momentDate.subtract(months, 'months');
  if (momentDate.date() < originalDay) {
    momentDate.endOf('month');
  } else {
    momentDate.date(originalDay);
  }
  return momentDate.format('YYYY-MM-DD HH:mm:ss.SSS');
};
/* harmony default export */ var utils_subtractMonths = (subtractMonths);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/OrderEligibleList/OrderEligibleList.js

















var OrderEligibleList = function OrderEligibleList(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var title = staticProps.title,
    imageWidth = staticProps.imageWidth,
    imageHeight = staticProps.imageHeight,
    fontSize = staticProps.fontSize,
    modalNotEligible = staticProps.modalNotEligible,
    monthIntervals = staticProps.monthIntervals,
    basePaths = staticProps.basePaths,
    noHasMoreProducts = staticProps.noHasMoreProducts,
    seeMoreText = staticProps.seeMoreText,
    displayMode = staticProps.displayMode;
  var config = config_default()();
  var _useCookies = (0,utils_build_esm/* useCookies */.fP)({}, config),
    accountData = _useCookies.accountData;
  var customerId = accountData.id;
  var route = structure.route;
  var TODAY_DATE = utils_subtractMonths(new Date(), 0);
  var PASS_DATE = utils_subtractMonths(new Date(), monthIntervals[0]);
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var icon = modalNotEligible.icon;
  var _useProductById = (0,build_esm.useProductById)(route.productId),
    product = _useProductById.product;
  var serviceSlug = utils_getServiceSlug(product == null ? void 0 : product.factsheet);
  var baseFinancialServiceUrl = "".concat(basePaths.financialService, "/?serviceSlug=").concat(serviceSlug);
  var _useState = (0,react.useState)(TODAY_DATE),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    createdAtLesser = _useState2[0],
    setCreatedAtLesser = _useState2[1];
  var _useState3 = (0,react.useState)(PASS_DATE),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    createdAtGreater = _useState4[0],
    setCreatedAtGreater = _useState4[1];
  var _useState5 = (0,react.useState)(1),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    monthCount = _useState6[0],
    setMonthCount = _useState6[1];
  var _useState7 = (0,react.useState)(true),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];
  var _useState9 = (0,react.useState)([]),
    _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
    productsList = _useState10[0],
    setProductsList = _useState10[1];
  var isMonthValided = function isMonthValided() {
    return monthCount < monthIntervals.length;
  };
  var _useEligibleProducts = (0,build_esm.useEligibleProducts)({
      createdAtGreater: createdAtGreater,
      createdAtLesser: createdAtLesser,
      customerId: customerId,
      serviceSlug: serviceSlug
    }),
    eligibleProducts = _useEligibleProducts.eligibleProducts,
    error = _useEligibleProducts.error,
    loading = _useEligibleProducts.loading;
  var handleSeeMorePage = function handleSeeMorePage() {
    if (isMonthValided()) {
      setMonthCount(function (prev) {
        return prev + 1;
      });
    } else {
      setIsLoading(false);
    }
  };
  var handleEligibleSetProducts = function handleEligibleSetProducts(eProducts) {
    if ((eProducts == null ? void 0 : eProducts.products.length) === 0) {
      handleSeeMorePage();
    } else if (eProducts) {
      setProductsList(function (prev) {
        return [].concat((0,toConsumableArray/* default */.Z)(prev), (0,toConsumableArray/* default */.Z)(eProducts.products));
      });
      setIsLoading(false);
    }
  };
  (0,react.useEffect)(function () {
    if (!isLoading) {
      if (productsList == null ? void 0 : productsList.length) {
        publish('order-eligible-list:impression', {
          displayMode: displayMode,
          products: productsList,
          serviceSlug: serviceSlug
        });
      } else {
        publish('order-not-eligible:impression', {
          serviceSlug: serviceSlug
        });
      }
    }
  }, [productsList, isLoading]);
  (0,react.useEffect)(function () {
    if (monthCount > 1) {
      setCreatedAtLesser(utils_subtractMonths(TODAY_DATE, monthIntervals[monthCount - 2]));
      setCreatedAtGreater(utils_subtractMonths(TODAY_DATE, monthIntervals[monthCount - 1]));
    }
  }, [monthCount]);
  (0,react.useEffect)(function () {
    !loading && handleEligibleSetProducts(eligibleProducts);
    error && setIsLoading(false);
  }, [eligibleProducts, error, loading]);
  var handleRedirectOnClick = function handleRedirectOnClick() {
    return (0,utils_build_esm/* routePush */.dY)({
      path: basePaths.insuranceService,
      spa: true
    });
  };
  var handleSelectedItem = function handleSelectedItem(order, index) {
    publish('order-eligible-list:click', {
      displayMode: displayMode,
      itemSelected: order,
      itemIndex: index,
      serviceSlug: serviceSlug
    });
  };
  var renderHeaderIcon = function renderHeaderIcon() {
    return react.createElement(ContainerIcon, null, react.createElement(esm/* Icon */.JO$, {
      name: icon.name,
      height: icon.height,
      width: icon.width,
      color: icon.color
    }));
  };
  var renderConfirmDialog = function renderConfirmDialog() {
    return react.createElement(ConfirmDialog/* default */.Z, {
      open: true,
      onClose: handleRedirectOnClick,
      title: modalNotEligible.title,
      infoText: utils_replaceTitle(modalNotEligible.describe, product == null ? void 0 : product.title),
      confirmText: modalNotEligible.confirmText,
      confirmAction: handleRedirectOnClick,
      headerComponent: renderHeaderIcon()
    });
  };
  var renderEligibleList = function renderEligibleList() {
    return react.createElement(react.Fragment, null, react.createElement(Title, {
      "data-testid": "order-eligible-list-title"
    }, title), productsList.map(function (order, index) {
      return react.createElement(LinkContainer, {
        key: order.orderUUID,
        href: utils_getProductUrl(baseFinancialServiceUrl, order.productSku, order.subOrderUUID),
        "data-testid": "product-card-container",
        onClick: function onClick() {
          return handleSelectedItem(order, index);
        }
      }, react.createElement(ImageBox, null, react.createElement(Image, {
        imageWidth: imageWidth,
        imageHeight: imageHeight,
        src: order.productImageUrl,
        alt: order.productDescription,
        "data-testid": "product-card-img"
      })), react.createElement(TextContainer, {
        "data-testid": "product-card-section"
      }, react.createElement(ProductTitle, {
        fontSize: fontSize,
        "data-testid": "product-card-title"
      }, order.productDescription)), react.createElement(ArrowBox, null, react.createElement(ArrowIcon, {
        name: "ChevronRight"
      })));
    }), isMonthValided() ? react.createElement(ButtonSeeMore, {
      "data-testid": "order-eligible-list-see-more",
      type: "button",
      color: "primary",
      onClick: handleSeeMorePage
    }, seeMoreText) : react.createElement(TextEmptyMessage, null, noHasMoreProducts));
  };
  var renderContent = function renderContent() {
    return productsList.length ? renderEligibleList() : renderConfirmDialog();
  };
  return isLoading ? react.createElement(atoms/* PageLoading */.SX, null) : react.createElement(PageContainer, {
    "data-testid": "order-eligible-list"
  }, renderContent());
};
var modalNotEligible = (0,prop_types.shape)({
  confirmText: prop_types.string,
  describe: prop_types.string,
  icon: (0,prop_types.shape)({
    color: prop_types.string,
    height: prop_types.string,
    name: prop_types.string,
    width: prop_types.string
  }),
  title: prop_types.string
});
var basePaths = (0,prop_types.shape)({
  financialService: prop_types.string.isRequired,
  insuranceService: prop_types.string.isRequired
}).isRequired;
var OrderEligibleListPropTypes =  false ? 0 : {};
 false ? 0 : void 0;
/* harmony default export */ var OrderEligibleList_OrderEligibleList = ((0,withLayoutProps/* default */.Z)(OrderEligibleList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/OrderEligibleList/index.js


/***/ })

}]);